import * as SQLite from 'expo-sqlite'
import { TABLE_NAME, TABLES_EXEPTIONS, TABLES_PENDINGS } from '../schemas'
import {
    FORM_SCHEDULE_STATUS,
    ID_DROPDOWN_USERS,
} from '../../src/components/stores/constants/constants.stores'
import DatabaseAdapter from '../adapters/DatabaseMethodAdapter'
import { SCHEDULES_STORE_NAMES } from '../../src/db/posSchedules'
// import { convertValueToQueryString, newcalculateDistance } from '../../src/utils/functions.utils';
import { PROGRESS_STEPS } from '../../src/redux/zustand/progressScheduleStore'
import { generateIdDateNow } from '../../src/utils/basicUtils'
// import { getCantQuestionPonderar } from '../../database/schedules.database';
// import { distanceInMeters } from '../../src/components/customUtils/calculateDistance';
import {
    FormAdditionalModel,
    ScheduleRecord,
    FormQuestionAnswerRecord,
    FormWithContent,
    StoreWithDetails,
    FormNameResult,
    AnswerItem,
    FormResult,
    ActivityAdvanceItem,
    DatabaseQueryResult,
    SQLiteRunResult,
    GetStoresParams,
    CheckinParams,
    StoresCountResult,
    FormsByNameResult,
    DatabaseRow,
    DatabaseRows,
    QueryParams,
} from '../../src/types/services'

// Funciones temporales hasta que las encontremos en su ubicación real
const convertValueToQueryString = (value: any): string => {
    if (value === null || value === undefined) return ''
    return String(value)
}

const newcalculateDistance = (
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number,
): number => {
    const R = 6371 // Radio de la Tierra en km
    const dLat = ((lat2 - lat1) * Math.PI) / 180
    const dLng = ((lng2 - lng1) * Math.PI) / 180
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
            Math.cos((lat2 * Math.PI) / 180) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return R * c * 1000 // Distancia en metros
}

const getCantQuestionPonderar = (questions: any[]) => {
    return {
        cantQuestionPonderar: questions.length,
        scoreTotalQuestionsPonderar: 100,
    }
}

const distanceInMeters = (
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number,
): number => {
    return newcalculateDistance(lat1, lng1, lat2, lng2)
}

// Función auxiliar para tipar consultas de base de datos
const typeDatabaseResult = <T>(result: unknown): T => {
    return result as T
}

// Función para generar IDs únicos
const generateUniqueId = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

// Interfaces específicas para consultas de base de datos
interface CampaignRow {
    _id: string
    name: string
    code: string
    image: string
    date_init: string
    date_finish: string
    steps: string
    total_progres: number
    schedules: string
    camp_values: string
    schedule_free: boolean
    date_moderation_init: string
    date_moderation_finish: string
    moderation: boolean
}

interface ScheduleRow {
    _id: string
    date_finish: string
    date_init: string
    form_finish: string
    form_init: string
    progress_diary: string
    additional: string
    distributor: string
    activities: string
    others_activities: string
    vacation: boolean
    activities_advances: string
    others_activities_advances: string
    forms_additionals: string
    forms_incidence: string
    reports: string
    data_version: number
}

interface PendingPosRow {
    store_id: string
    schedule_id: string
}

interface StoreDataRow {
    _id: string
    name: string
    code: string
    [key: string]: any
}

interface StatusCountRow {
    status: string
    count: number
}

interface GenericScheduleStoreRow {
    _id: string
    store_id: string
    schedule_id: string
    name: string
    code: string
    address: string
    forms: string
    campaign_status: number
    lat: number
    lng: number
    forms_relevant: string
    forms_featured: string
    segment: string
    forms_advances: string
    cluster: string
    [key: string]: any
}

interface FormStoreRow {
    forms: string
    pos_id: string
    [key: string]: any
}

interface AnswerStoreRow {
    store_id: string
    [key: string]: any
}

interface ScheduleRecordRow {
    objectives: string
    forms: string
    [key: string]: any
}

interface FormQuestionAnswerRow {
    _id: string
    answers: string
    questions: string
    type_form: string
    date_init: string
    status: string
    repeat: string
    totalScore: number
    scoreObtained: number
    cant_questions_yes_na: number
    progress_questions_yes_na: number
    scoreTotalQuestionsPonderar: number
    name_form: string
    heladera: string
    create_refrigerator: string
    form_id_father: string
    [key: string]: any
}

interface FormRow {
    contents: string
    type_form: string
    medias?: string
    type?: string
    name_form: string
    _id: string
    answers?: string
    [key: string]: any
}

interface ActivityRow {
    activities: string
    [key: string]: any
}

interface StoreLocationRow {
    store_id: string
    schedule_id: string
    name: string
    code: string
    address: string
    forms: string
    campaign_status: number
    segment: string
    cluster: string
    lat: number
    lng: number
    forms_relevant: string
    forms_featured: string
    forms_advances: string
    _id: string
    [key: string]: any
}

class ScheduleServices {
    private static instance: SQLite.SQLiteDatabase

    private constructor() {}

    public static async getLatestFormAdditional(): Promise<
        FormAdditionalModel[] | null
    > {
        try {
            const form_additional = (await DatabaseAdapter.getAll(`
                SELECT * 
                FROM ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS} 
                ORDER BY date_finish
                DESC 
                LIMIT 1;`)) as FormAdditionalModel[]
            // console.log('28 -- result', result)
            // let form_additional = result.rows.item(0)
            return form_additional.length > 0 ? form_additional : null
            // if (form_additional && Object.keys(form_additional).length > 0) {
            //     return form_additional
            // }

            // return null
        } catch (error) {
            console.error('Error getting latest form additional', error)
            throw new Error('Error getting latest form additional')
        }
    }

    public static async getFormsAdditionals(): Promise<FormAdditionalModel[]> {
        try {
            const forms_additionals = (await DatabaseAdapter.getAll(`
                SELECT *
                FROM ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS};
                `)) as FormAdditionalModel[]
            if (forms_additionals && forms_additionals.length > 0) {
                const newFormsAdditionals = forms_additionals.map(
                    (form: FormAdditionalModel) => {
                        return {
                            ...form,
                            questions:
                                typeof form.questions === 'string'
                                    ? JSON.parse(form.questions)
                                    : form.questions,
                        } as FormAdditionalModel
                    },
                )
                return newFormsAdditionals
            }

            return []
        } catch (error) {
            console.error('Error getting forms additionals', error)
            throw new Error('Error getting forms additionals')
        }
    }

    public static async saveFormsAdditionals(
        newFormsAdditionals: FormAdditionalModel[],
    ): Promise<FormAdditionalModel[] | void> {
        try {
            if (!newFormsAdditionals || newFormsAdditionals.length === 0) {
                return
            }

            await DatabaseAdapter.exec(
                `DELETE FROM ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS};`,
            )

            for (const form of newFormsAdditionals) {
                const _id = form._id
                const title = form.title
                const date = form.date
                const date_finish = form.date_finish
                const icon = form.icon
                const questions = JSON.stringify(form.questions)

                const query = `
                    INSERT INTO ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS} (
                        _id, 
                        title, 
                        date, 
                        date_finish, 
                        icon, 
                        questions
                    ) VALUES (?,?,?,?,?,?);
                `
                const params = [_id, title, date, date_finish, icon, questions]

                const result = await DatabaseAdapter.run(query, params)
                console.log('84 -- result', result)
            }
        } catch (error) {
            console.error('Error saving forms additionals', error)
            throw new Error('Error saving forms additionals')
        }
    }

    public static async getAllCampaigns(): Promise<any[]> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT *
                    FROM ${TABLE_NAME.SCHEDULE_CAMPAINGS};
                `)

            const campaigns = []

            for (let i = 0; i < result.length; i++) {
                const row = typeDatabaseResult<CampaignRow>(result[i])
                const scheduleIds = JSON.parse(row.schedules)

                campaigns.push({
                    _id: row._id,
                    name: row.name,
                    code: row.code,
                    image: row.image,
                    date_int: row.date_init,
                    date_finish: row.date_finish,
                    steps: JSON.parse(row.steps),
                    total_progres: row.total_progres,
                    scheduleIds: scheduleIds,
                    values: JSON.parse(row.camp_values),
                    schedules: [],
                    schedule_free: row.schedule_free,
                    date_moderation_init: row.date_moderation_init,
                    date_moderation_finish: row.date_moderation_finish,
                    moderation: row.moderation,
                })
            }

            const campaignsResult = []

            for (let campaign of campaigns) {
                const scheduleIds = campaign.scheduleIds
                const scheduleDetail = []
                for (const scheduleId of scheduleIds) {
                    let scheduleResult = await DatabaseAdapter.getAll(
                        `
                                SELECT *
                                FROM ${TABLE_NAME.SCHEDULES}
                                WHERE _id = ?;`,
                        [scheduleId],
                    )

                    if (scheduleResult && scheduleResult.length > 0) {
                        const scheduleRow = typeDatabaseResult<ScheduleRow>(
                            scheduleResult[0],
                        )

                        const schedule = {
                            _id: scheduleRow._id,
                            date_finish: scheduleRow.date_finish,
                            date_init: scheduleRow.date_init,
                            form_finish:
                                scheduleRow.form_finish.length > 6
                                    ? JSON.parse(scheduleRow.form_finish)
                                    : null,
                            form_init:
                                scheduleRow.form_init.length > 6
                                    ? JSON.parse(scheduleRow.form_init)
                                    : null,
                            stores: [], //JSON.parse(scheduleRow.stores), // [],
                            progress_diary: scheduleRow.progress_diary,
                            additional: JSON.parse(scheduleRow.additional),
                            distributor: JSON.parse(scheduleRow.distributor),
                            activities: JSON.parse(scheduleRow.activities),
                            others_activities: JSON.parse(
                                scheduleRow.others_activities,
                            ),
                            vacation: scheduleRow.vacation,
                            activities_advances: JSON.parse(
                                scheduleRow.activities_advances,
                            ),
                            others_activities_advances: JSON.parse(
                                scheduleRow.others_activities_advances,
                            ),
                            forms_additionals: JSON.parse(
                                scheduleRow.forms_additionals,
                            ),
                            forms_incidence: scheduleRow.forms_incidence,
                            reports: JSON.parse(scheduleRow.reports),
                            data_version: scheduleRow.data_version,
                        }

                        scheduleDetail.push(schedule)
                    }
                }

                campaign.schedules = scheduleDetail

                campaignsResult.push(campaign)
            }

            // const schedulePromises = campaigns.map((campaign) => {
            //     const scheduleIds = campaign.scheduleIds
            //     const scheduleDetailPromises = scheduleIds.map((scheduleId) => {
            //         let scheduleResult = DatabaseAdapter.getAll(
            //             `
            //                     SELECT *
            //                     FROM ${TABLE_NAME.SCHEDULES}
            //                     WHERE _id = ?;`,
            //             [scheduleId],
            //         )

            //         if (scheduleResult && scheduleResult.length > 0) {
            //             const scheduleRow = scheduleResult[0]

            //             const schedule = {
            //                 _id: scheduleRow._id,
            //                 date_finish: scheduleRow.date_finish,
            //                 date_init: scheduleRow.date_init,
            //                 form_finish: scheduleRow.form_finish.length > 6 ? JSON.parse(scheduleRow.form_finish) : null,
            //                 form_init: scheduleRow.form_init.length > 6 ? JSON.parse(scheduleRow.form_init) : null,
            //                 stores: [], //JSON.parse(scheduleRow.stores), // [],
            //                 progress_diary: scheduleRow.progress_diary,
            //                 additional: JSON.parse(scheduleRow.additional),
            //                 distributor: JSON.parse(scheduleRow.distributor),
            //                 activities: JSON.parse(scheduleRow.activities),
            //                 others_activities: JSON.parse(scheduleRow.others_activities),
            //                 vacation: scheduleRow.vacation,
            //                 activities_advances: JSON.parse(scheduleRow.activities_advances),
            //                 others_activities_advances: JSON.parse(scheduleRow.others_activities_advances),
            //                 forms_additionals: JSON.parse(scheduleRow.forms_additionals),
            //                 forms_incidence: scheduleRow.forms_incidence,
            //                 reports: JSON.parse(scheduleRow.reports),
            //                 data_version: scheduleRow.data_version,
            //             }

            //             return schedule
            //         } else {
            //             // rejectSchedule(new Error('Schedule not found'))
            //         }
            //     })

            //     return Promise.all(scheduleDetailPromises).then((schedulesData) => {
            //         // console.log('3937 -- 🚀 ~ Promise.all ~ schedulesData:', schedulesData)
            //         campaign.schedules = schedulesData
            //     })
            // })

            // const resultPromise = await Promise.all(schedulePromises)
            // .then(() => {
            //     //   console.log("🚀 ~ Promise.all ~ campaigns:", campaigns)
            //     // resolve(campaigns)
            //     return campaigns
            // })
            // .catch((error) => console.error(error))

            // return resultPromise
            return campaignsResult
        } catch (error) {
            console.error('Error getting all campaigns', error)
            throw new Error('Error getting all campaigns')
        }
    }

    public static async addCampaing(campaing): Promise<any> {
        try {
            const result = await DatabaseAdapter.getAll(
                `
                    SELECT *
                    FROM ${TABLE_NAME.SCHEDULE_CAMPAINGS}
                    WHERE _id = ?;`,
                [campaing._id],
            )

            const count = result.length
            console.log(
                '175 ---- 🚀 ~ ScheduleServices ~ addCampaing ~ count:',
                count,
            )

            if (count === 0) {
                let agendas_ids = campaing.schedules.map((item) => item._id)
                console.log(
                    '179 -- 🚀 ~ ScheduleServices ~ addCampaing ~ agendas_ids:',
                    agendas_ids,
                )

                let insertCampaing = [
                    campaing._id,
                    campaing.name,
                    campaing.code,
                    campaing.image,
                    campaing.date_int,
                    campaing.date_finish,
                    JSON.stringify(campaing.steps || {}),
                    campaing.total_progres,
                    JSON.stringify(agendas_ids),
                    JSON.stringify(campaing.values),
                    campaing.schedule_free,
                    campaing.date_moderation_init,
                    campaing.date_moderation_finish,
                    campaing.moderation,
                ]

                console.log(
                    '199 -- 🚀 ~ ScheduleServices ~ addCampaing ~ insertCampaing:',
                    insertCampaing,
                )

                const result = await DatabaseAdapter.run(
                    `
                            INSERT INTO ${TABLE_NAME.SCHEDULE_CAMPAINGS} (
                                _id, 
                                name, 
                                code, 
                                image, 
                                date_init, 
                                date_finish, 
                                steps, 
                                total_progres, 
                                schedules, 
                                camp_values, 
                                schedule_free, 
                                date_moderation_init, 
                                date_moderation_finish, 
                                moderation
                            )
                                VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?);`,
                    insertCampaing,
                )

                return result
            } else {
                // console.log('existingCampaing', result[0])
                const existingCampaing = typeDatabaseResult<CampaignRow>(result[0])
                if (
                    existingCampaing.date_moderation_init !==
                        campaing.date_moderation_init ||
                    existingCampaing.date_moderation_finish !==
                        campaing.date_moderation_finish ||
                    existingCampaing.moderation !== campaing.moderation
                ) {
                    const updateCampaing = [
                        campaing.date_moderation_init,
                        campaing.date_moderation_finish,
                        campaing.moderation,
                        campaing._id,
                    ]

                    const result = await DatabaseAdapter.run(
                        `
                            UPDATE ${TABLE_NAME.SCHEDULE_CAMPAINGS}
                            SET date_moderation_init = ?,
                                date_moderation_finish = ?,
                                moderation = ?
                            WHERE _id = ?;`,
                        updateCampaing,
                    )

                    return result
                }
            }
        } catch (error) {
            console.error(
                '246   -- 🚀 ~ ScheduleServices ~ addCampaing ~ error:',
                error,
            )
            throw new Error('247 --- Error adding campaing')
        }
    }

    public static async addInfoCreateStores(data): Promise<void> {
        try {
            const insertCreateStore = [
                '1',
                JSON.stringify(data.forms),
                JSON.stringify(data.areas || []),
                data.maximum_distance_for_checkin || 0,
            ]

            const result = await DatabaseAdapter.run(
                `
                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_CREATE_STORES} (
                    _id, 
                    forms,
                    areas,
                    maximum_distance_for_checkin
                )
                    VALUES (?,?,?,?);`,
                insertCreateStore,
            )
        } catch (error) {
            console.error('Error adding info create stores', error)
            throw new Error('Error adding info create stores')
        }
    }

    public static async getLatestAdvanceSchedule(): Promise<Object | null> {
        try {
            const result = await DatabaseAdapter.getFirst(`
                    SELECT *
                    FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                    ORDER BY date_modified
                    DESC LIMIT 1;
                `)

            return result ? result : null
        } catch (error) {
            console.error('Error getting latest advance schedule', error)
            throw new Error('Error getting latest advance schedule')
        }
    }

    public static async addSchedulesBatch(schedules, campaign_id) {
        try {
            const batchSize = 1000 // Tamaño del lote
            let startIndex = 0

            const insertNextBatch = async () => {
                const batchSchedules = schedules.slice(
                    startIndex,
                    startIndex + batchSize,
                )

                if (batchSchedules.length > 0) {
                    try {
                        const queries = batchSchedules
                            .map((schedule) => {
                                const values = [
                                    schedule._id,
                                    schedule.date_finish,
                                    schedule.date_init,
                                    JSON.stringify(schedule.form_finish || {}),
                                    JSON.stringify(schedule.form_init || {}),
                                    '[]', // stores vacíos en este caso
                                    campaign_id,
                                    schedule.progress_diary,
                                    JSON.stringify(schedule.additional || {}),
                                    JSON.stringify(schedule.activities || []),
                                    JSON.stringify(schedule.others_activities || []),
                                    JSON.stringify(schedule.distributor),
                                    schedule.vacation || false,
                                    JSON.stringify(
                                        schedule.activities_advances || {},
                                    ),
                                    JSON.stringify(
                                        schedule.others_activities_advances || {},
                                    ),
                                    JSON.stringify(schedule.forms_additionals || []),
                                    schedule.forms_incidence || false,
                                    JSON.stringify(schedule.reports || {}),
                                    schedule.data_version,
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULES} (
                                    _id,
                                    date_finish,
                                    date_init,
                                    form_finish,
                                    form_init,
                                    stores,
                                    campaign_id,
                                    progress_diary,
                                    additional,
                                    activities,
                                    others_activities,
                                    distributor,
                                    vacation,
                                    activities_advances,
                                    others_activities_advances,
                                    forms_additionals,
                                    forms_incidence,
                                    reports,
                                    data_version
                                ) VALUES (${values});
                            `
                            })
                            .join('')

                        await DatabaseAdapter.exec(queries)

                        startIndex += batchSize
                        insertNextBatch()
                    } catch (error) {
                        console.error('488 -- Error adding schedules', error)
                        throw new Error('489 --- Error adding schedules')
                    }
                } else {
                    return
                }
            }

            insertNextBatch()
        } catch (error) {
            console.error('Error adding schedules', error)
            throw new Error('Error adding schedules')
        }
    }

    public static async deleteTableRegister(table: string, retryCount = 0) {
        const MAX_RETRIES = 3
        const RETRY_DELAY = 100 // ms

        try {
            await DatabaseAdapter.exec(`DELETE FROM ${table};`)
            console.log(`✅ Table ${table} cleared successfully`)
        } catch (error: any) {
            // Manejar database locked con retry
            if (
                error?.message?.includes('database is locked') &&
                retryCount < MAX_RETRIES
            ) {
                console.warn(
                    `⚠️ [deleteTableRegister] Database locked, retrying ${retryCount + 1}/${MAX_RETRIES}...`,
                )
                await new Promise((resolve) =>
                    setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                )
                return ScheduleServices.deleteTableRegister(table, retryCount + 1)
            }
            console.error(`Error deleting table register from ${table}:`, error)
            throw new Error(
                `Error deleting table register: ${error?.message || error}`,
            )
        }
    }

    public static async addStores(stores, batchSize = 1000, step, setProgress) {
        try {
            let startIndex = 0
            const totalStores = stores.length

            const updateProgress = (currentIndex) => {
                const { start, end } = PROGRESS_STEPS[step]

                const progress = Math.round(
                    start + (end - start) * (currentIndex / totalStores),
                )
                setProgress(progress)
            }

            const insertNextBatch = async () => {
                const batchStores = stores.slice(startIndex, startIndex + batchSize)
                if (batchStores.length > 0) {
                    try {
                        const queries = batchStores
                            .map((store) => {
                                const values = [
                                    store._id,
                                    store.name,
                                    store.address,
                                    parseFloat(store.lat),
                                    parseFloat(store.lng),
                                    store.code,
                                    store.cluster,
                                    store.area,
                                    store.region,
                                    store.format,
                                    store.flag,
                                    store.maximum_distance_for_checkin,
                                    store.segment,
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES} (
                                    _id,
                                    name,
                                    address,
                                    lat,
                                    lng,
                                    code,
                                    cluster,
                                    area,
                                    region,
                                    format,
                                    flag,
                                    maximum_distance_for_checkin,
                                    segment
                                ) VALUES (${values});
                            `
                            })
                            .join('')

                        await DatabaseAdapter.exec(queries)

                        startIndex += batchSize
                        if (step != null && setProgress != null) {
                            updateProgress(startIndex)
                        }
                        await insertNextBatch() // Insertar el próximo lote
                    } catch (error) {
                        console.error('440 -- Error adding stores', error)
                        throw new Error('441 --- Error adding stores')
                    }
                }
            }

            await insertNextBatch()
        } catch (error) {
            console.error('Error adding stores', error)
            throw new Error('Error adding stores')
        }
    }

    public static async addAdvancesSchedules(advancesSchedules) {
        try {
            if (advancesSchedules && advancesSchedules.length > 0) {
                for (const adv of advancesSchedules) {
                    const query = `
                            INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_ADVANCES} (
                                _id,
                                pos_id,
                                schedule_id,
                                forms,
                                status,
                                date_init,
                                form_id,
                                progress,
                                score,
                                checkin_id,
                                date_modified,
                                distributor_id,
                                objectives
                                last_checkout
                            ) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?);
                        `

                    const params = [
                        adv._id,
                        adv.pos_id || null,
                        adv.schedule_id,
                        JSON.stringify(adv.forms || []),
                        adv.status,
                        adv.date_init,
                        adv.form_id || '',
                        adv.progress,
                        adv.score,
                        adv.checkin_id,
                        adv.date_modified,
                        adv.distributor_id || '',
                        JSON.stringify(adv.objectives || []),
                        adv.last_checkout || null,
                    ]

                    const result = await DatabaseAdapter.run(query, params)
                    // console.log("556 --- 🚀 ~ ScheduleServices ~ addAdvancesSchedules ~ result:", result)
                }

                // const queries = advancesSchedules.map((adv) => {
                //     const values = [
                //         adv._id,
                //         adv.pos_id || null,
                //         adv.schedule_id,
                //         // adv.adv_id,
                //         JSON.stringify(adv.forms || []),
                //         adv.status,
                //         adv.date_init,
                //         adv.form_id || '',
                //         adv.progress,
                //         adv.score,
                //         adv.checkin_id,
                //         adv.date_modified,
                //         adv.distributor_id || '',
                //         JSON.stringify(adv.objectives || []),
                //     ].map(convertValueToQueryString).join(',');

                //     console.log('587 ---- values', values)

                //     return `
                //         INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_ADVANCES} (
                //             _id,
                //             pos_id,
                //             schedule_id,
                //             forms,
                //             status,
                //             date_init,
                //             form_id,
                //             progress,
                //             score,
                //             checkin_id,
                //             date_modified,
                //             distributor_id,
                //             objectives
                //         ) VALUES (${values});
                //     `;
                // })

                // console.log('✅✅✅510 -- queries', queries)

                // await DatabaseAdapter.exec(queries);

                // return result
            }
        } catch (error) {
            console.error('Error adding advances schedules', error)
            throw new Error('Error adding advances schedules')
        }
    }

    public static async addPosSchedules(
        posSchedules,
        batchSize = 1000,
        step,
        setProgress,
    ) {
        try {
            if (posSchedules && posSchedules.length > 0) {
                let startIndex = 0

                const totalposSchedules = posSchedules.length

                const updateProgress = (currentIndex) => {
                    const { start, end } = PROGRESS_STEPS[step]

                    const progress = Math.round(
                        start + (end - start) * (currentIndex / totalposSchedules),
                    )
                    setProgress(progress)
                }

                const insertNextBatch = async () => {
                    const batchStores = posSchedules.slice(
                        startIndex,
                        startIndex + batchSize,
                    )
                    if (batchStores.length > 0) {
                        const queries = batchStores
                            .map((schedule) => {
                                const values = [
                                    schedule._id,
                                    schedule.store_id,
                                    schedule.schedule_id,
                                    JSON.stringify(schedule.forms || []),
                                    JSON.stringify(schedule.forms_relevant),
                                    JSON.stringify(schedule.forms_featured),
                                    schedule.campaign_status,
                                    parseFloat(schedule.lat),
                                    parseFloat(schedule.lng),
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} (
                                    _id,
                                    store_id,
                                    schedule_id,
                                    forms,
                                    forms_relevant,
                                    forms_featured,
                                    campaign_status,
                                    lat,
                                    lng
                                ) VALUES (${values});
                            `
                            })
                            .join('')

                        await DatabaseAdapter.exec(queries)

                        startIndex += batchSize
                        if (step != null && setProgress != null) {
                            updateProgress(startIndex)
                        }
                        insertNextBatch()

                        // //*
                        // const placeholders = batchStores.map(() => '(?,?,?,?,?,?,?,?,?)').join(',')

                        // const values = batchStores.flatMap((schedule) => [
                        //     schedule._id,
                        //     schedule.store_id,
                        //     schedule.schedule_id,
                        //     JSON.stringify(schedule.forms || []),
                        //     JSON.stringify(schedule.forms_relevant),
                        //     JSON.stringify(schedule.forms_featured),
                        //     schedule.campaign_status,
                        //     parseFloat(schedule.lat),
                        //     parseFloat(schedule.lng),
                        // ])

                        // const result = await ScheduleServices.instance.execAsync(
                        //     `

                        //     INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} (
                        //             _id,
                        //             store_id,
                        //             schedule_id,
                        //             forms,
                        //             forms_relevant,
                        //             forms_featured,
                        //             campaign_status,
                        //             lat,
                        //             lng
                        //     ) VALUES ${placeholders};`,
                        //     values,
                        // )

                        // startIndex += batchSize

                        // insertNextBatch()
                    } else {
                        return
                    }
                }

                insertNextBatch()
            } else {
                return
            }
        } catch (error) {
            console.error('Error adding pos schedules', error)
            throw new Error('Error adding pos schedules')
        }
    }

    public static async addAllFormsPF(data, batchSize = 1000) {
        try {
            let startIndex = 0

            const insertNextBatch = async () => {
                try {
                    const batch = data.slice(startIndex, startIndex + batchSize)

                    if (batch && batch.length > 0) {
                        const queries = batch
                            .map((form) => {
                                const values = [
                                    form._id,
                                    form.status,
                                    form.index,
                                    form.title,
                                    form.icon,
                                    JSON.stringify(form.medias),
                                    JSON.stringify(form.type),
                                    form.start_ejecution,
                                    form.end_ejecution,
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE} (
                                _id,
                                status,
                                form_index,
                                title,
                                icon,
                                medias,
                                type,
                                start_ejecution,
                                end_ejecution
                            )
                            VALUES (${values});
                        `
                            })
                            .join('')

                        await DatabaseAdapter.exec(queries)
                        startIndex += batchSize
                        insertNextBatch() // Insertar el próximo lote
                    }
                } catch (error) {
                    console.error('1Error adding all forms PF', error)
                    throw new Error('1Error adding all forms PF')
                }
            }

            insertNextBatch()
        } catch (error) {
            console.error('Error adding all forms PF', error)
            throw new Error('Error adding all forms PF')
        }
    }

    public static async addAllStoresPFrelation(data, batchSize = 1000) {
        try {
            let startIndex = 0

            const insertNextBatch = async () => {
                try {
                    const batch = data.slice(startIndex, startIndex + batchSize)

                    console.log('8000 --- batch length', batch.length)
                    if (batch && batch.length > 0) {
                        const queries = batch
                            .map((item) => {
                                const values = [
                                    item.pos_id,
                                    item.pos_id,
                                    JSON.stringify(item.forms_ids),
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_PF_RELATION} (
                                    _id,
                                    pos_id,
                                    forms_id
                                ) VALUES (${values});
                            `
                            })
                            .join('')

                        const res = await DatabaseAdapter.exec(queries)
                        console.log(
                            '822 -- 🚀 ~ ScheduleServices ~ insertNextBatch ~ res:',
                            res,
                        )
                        startIndex += batchSize
                        insertNextBatch() // Insertar el próximo lote
                    }
                } catch (error) {
                    console.error('2Error adding all stores PF relation', error)
                    throw new Error('2Error adding all stores PF relation')
                }
            }

            insertNextBatch()
        } catch (error) {
            console.error('Error adding all stores PF relation', error)
            throw new Error('Error adding all stores PF relation')
        }
    }

    public static async add_checkin(data, checkin_id = '', distributor_id = '') {
        try {
            const insertCheckin = [
                data.date,
                data.store_id,
                data.lat_checkin,
                data.lng_checkin,
                checkin_id,
                data.schedule_id,
                data.date_init,
                data.dif_utc,
                data.status,
                distributor_id,
            ]

            const result = await DatabaseAdapter.run(
                `
                INSERT INTO ${TABLE_NAME.SCHEDULE_CHECKIN} (
                    date,
                    store_id,
                    lat_checkin,
                    lng_checkin,
                    checkin_id,
                    schedule_id,
                    date_init,
                    dif_utc,
                    status,
                    distributor_id
                )
                VALUES (?, ?, ?, ?, ?, ?,?, ?, ?,?);`,
                insertCheckin,
            )

            // console.log('782 --- result', JSON.stringify(result))
            return result
        } catch (error) {
            console.error('Error adding checkin', error)
            throw new Error('Error adding checkin')
        }
    }

    public static async update_status_store(
        storeId,
        scheduleId,
        newStatus,
        dateInit,
        distributor = false,
    ) {
        try {
            let updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                        SET status = ?
                        WHERE pos_id = ? AND schedule_id = ? `

            if (distributor) {
                updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                                 SET status = ?
                                 WHERE distributor_id = ? AND schedule_id = ? AND status = ${FORM_SCHEDULE_STATUS.IN_PROGRESS}`
            }

            const result = await DatabaseAdapter.run(updateQuery, [
                newStatus,
                storeId,
                scheduleId,
            ])
            console.log(
                '628 -- 🚀 ~ ScheduleServices ~ update_status_store ~ result:',
                result,
            )

            if (result.changes == 0) {
                // Si no se encontró ningún registro para actualizar, insertamos uno nuevo
                const insertQuery = distributor
                    ? `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES}
                    (_id, distributor_id, schedule_id, status, date_init, date_modified)
                    VALUES (?, ?, ?, ?, ?,?)`
                    : `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES}
                                 (_id, pos_id, schedule_id, status, date_init, date_modified)
                                 VALUES (?, ?, ?, ?, ?,?)`

                const newId = generateUniqueId() // Genera un nuevo ID único

                const inserValues = DatabaseAdapter.run(insertQuery, [
                    newId,
                    storeId,
                    scheduleId,
                    newStatus,
                    dateInit,
                    new Date().toISOString(),
                ])

                return inserValues
            }
        } catch (error) {
            console.error('Error updating status store', error)
            throw new Error('Error updating status store')
        }
    }

    public static async hasSchedulePosInDatabase(
        totalSchedulePos,
    ): Promise<boolean> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT COUNT(*) 
                    FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS};
                `)

            const count = result[0]['COUNT(*)']

            return count == totalSchedulePos
        } catch (error) {
            console.error('Error checking schedule pos in database', error)
            throw new Error('Error checking schedule pos in database')
        }
    }

    public static async hasStoresInDatabase(totalStores): Promise<boolean> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT COUNT(*) 
                    FROM ${TABLE_NAME.SCHEDULE_STORES};
                `)

            const count = result[0]['COUNT(*)']

            return count == totalStores
        } catch (error) {
            console.error('Error checking stores in database', error)
            throw new Error('Error checking stores in database')
        }
    }

    public static async CheckSavedRecords(
        table: string,
        total: number,
    ): Promise<boolean> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT COUNT(*) 
                    FROM ${table}
                    WHERE wise = 0;
                `)
            const count = result[0]['COUNT(*)']

            return count >= total
        } catch (error) {
            console.error('Error checking saved records', error)
            throw new Error('Error checking saved records')
        }
    }

    public static async hasFormsPerfectStoreInDatabase(
        totalFormsPerfecStore: number,
    ): Promise<boolean> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT COUNT(*) 
                    FROM ${TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE};
                `)
            const count = result[0]['COUNT(*)']

            return count == totalFormsPerfecStore
        } catch (error) {
            console.error('Error checking forms perfect store in database', error)
            throw new Error('Error checking forms perfect store in database')
        }
    }

    public static async hasRelationPerfectStoreInDatabase(
        totalRelationPerfectStore: number,
    ): Promise<boolean> {
        try {
            const result = await DatabaseAdapter.getAll(`
                    SELECT COUNT(*) 
                    FROM ${TABLE_NAME.SCHEDULE_STORES_PF_RELATION};
                `)
            const count = result[0]['COUNT(*)']

            return count == totalRelationPerfectStore
        } catch (error) {
            console.error('Error checking relation perfect store in database', error)
            throw new Error('Error checking relation perfect store in database')
        }
    }

    public static async addAllForms(
        forms,
        wise = false,
        heladera = false,
        create_refrigerator = false,
        form_id_father = '',
    ) {
        try {
            if (forms && forms.length > 0) {
                const batchSize = 1000 // Tamaño del lote
                let startIndex = 0

                const insertNextBatch = async () => {
                    // const batchForms = forms && forms.length > 0 ? forms.slice(startIndex, startIndex + batchSize) : []

                    const batchForms = forms.slice(
                        startIndex,
                        startIndex + batchSize,
                    )

                    if (batchForms.length > 0) {
                        const queries = batchForms
                            .map((form) => {
                                const values = [
                                    form._id,
                                    form.index_form,
                                    form.repeat,
                                    form.can_repeat,
                                    form.icon,
                                    form.check_in,
                                    form.name_form,
                                    form.icon_check,
                                    JSON.stringify(form.type_form),
                                    JSON.stringify(form.contents),
                                    JSON.stringify(form.segments),
                                    typeof form.status !== 'undefined' &&
                                    form.status !== null
                                        ? form.status
                                        : 0, // status (preserve server status when provided)
                                    form.progress,
                                    form.totalScore,
                                    form.show_barcode,
                                    JSON.stringify(form.tags),
                                    wise,
                                    heladera,
                                    create_refrigerator,
                                    form_id_father,
                                    form.start_ejecution,
                                    form.end_ejecution,
                                ]
                                    .map(convertValueToQueryString)
                                    .join(',')

                                return `
                                INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORE_FORMS} (
                                    _id,
                                    index_form,
                                    repeat,
                                    can_repeat,
                                    icon,
                                    check_in,
                                    name_form,
                                    icon_check,
                                    type_form,
                                    contents,
                                    segments,
                                    status,
                                    progress,
                                    totalScore,
                                    show_barcode,
                                    tags,
                                    wise,
                                    heladera,
                                    create_refrigerator,
                                    form_id_father,
                                    start_ejecution,
                                    end_ejecution,
                                    scores,
                                    weights
                                ) VALUES (${values});
                            `
                            })
                            .join('')

                        await DatabaseAdapter.exec(queries)

                        startIndex += batchSize
                        insertNextBatch() // Insertar el próximo lote
                    } else {
                        return
                    }
                }

                insertNextBatch() // Comenzar la inserción en lotes
            } else {
                return
            }
        } catch (error) {
            throw new Error('Error adding forms')
        }
    }

    public static async addOrUpdateAdvanceSchedule(schedule) {
        try {
            let query = ''
            let selectParams = []
            let whereClause = ''
            let updateParams = []

            let commonParams = [
                schedule._id,
                JSON.stringify(schedule.forms || []),
                schedule.status,
                schedule.form_id || '',
                schedule.progress,
                schedule.score,
                schedule.checkin_id,
                schedule.date_modified,
            ]

            // Caso 1: Si es form_id
            if (schedule.form_id && schedule.form_id !== '') {
                whereClause = `form_id = ? AND schedule_id = ? AND date(date_init, 'localtime') = date('now', 'localtime')`
                selectParams = [schedule.form_id, schedule.schedule_id]
            }
            // Caso 2: Si es distributor_id
            else if (schedule.distributor_id && schedule.distributor_id !== '') {
                whereClause = `distributor_id = ? AND schedule_id = ? AND date(date_init, 'localtime') = date('now', 'localtime')`
                selectParams = [schedule.distributor_id, schedule.schedule_id]
            }
            // Caso 3: Si es pos_id
            else {
                whereClause = `pos_id = ? AND schedule_id = ? AND date(date_init, 'localtime') = date('now', 'localtime') AND (checkin_id = ? OR checkin_id IS NULL)`
                selectParams = [
                    schedule.pos_id,
                    schedule.schedule_id,
                    schedule.checkin_id,
                ]
            }

            // Construimos la consulta SELECT
            query = `SELECT 1 FROM ${TABLE_NAME.SCHEDULE_ADVANCES} WHERE ${whereClause};`

            // Ejecutamos la consulta SELECT

            const result = await DatabaseAdapter.getAll(query, selectParams)

            if (result && result.length > 0) {
                // Si existe, actualiza el registro
                const updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                                        SET _id = ?, forms = ?, status = ?, form_id = ?, progress = ?,score = ?, checkin_id = ?, date_modified = ?
                                        WHERE ${whereClause};`
                updateParams = [...commonParams, ...selectParams]

                const result2 = await DatabaseAdapter.run(updateQuery, updateParams)

                return result2
            } else {
                // Si no existe, inserta el nuevo registro
                const insertQuery = `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES} (
                                            _id, pos_id, schedule_id, forms, status, date_init, form_id, progress, score, checkin_id, date_modified, distributor_id
                                         ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?,?);`

                const insertParams = [
                    schedule._id,
                    schedule.pos_id,
                    schedule.schedule_id,
                    JSON.stringify(schedule.forms || []),
                    schedule.status,
                    schedule.date_init,
                    schedule.form_id || '',
                    schedule.progress,
                    schedule.score,
                    schedule.checkin_id,
                    schedule.date_modified,
                    schedule.distributor_id || '',
                ]

                const result3 = await DatabaseAdapter.run(insertQuery, insertParams)

                return result3
            }
        } catch (error) {
            console.error('Error adding or updating advance schedule', error)
            // throw new Error('Error adding or updating advance schedule')
        }
    }

    public static async add_checkout(data, checkout_id = '', distributor_id = '') {
        try {
            const query = `INSERT INTO ${TABLE_NAME.SCHEDULE_CHECKOUT} (
                date,
                store_id,
                lat_checkout,
                lng_checkout,
                checkout_id,
                checkin_id,
                schedule_id,
                date_finish,
                dif_utc, 
                status,
                checkin_id_local,
                distributor_id
            ) VALUES (?, ?, ?, ?, ?, ?, ?,?,?,?,?,?)`
            const params = [
                data.date,
                data.store_id,
                data.lat_checkout,
                data.lng_checkout,
                checkout_id,
                data.checkin_id,
                data.schedule_id,
                data.date_finish,
                data.dif_utc,
                data.status,
                data.checkin_id_local,
                distributor_id,
            ]

            const result = await DatabaseAdapter.run(query, params)
            // console.log('928 --- result', result)
            return result
        } catch (error) {
            console.error('Error adding checkout', error)
            throw new Error('Error adding checkout')
        }
    }

    public static async get_checkins_pending(status_pending_connection) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKIN} WHERE status =?`
            const params = [status_pending_connection]

            const result = await DatabaseAdapter.getAll(query, params)

            return result
        } catch (error) {
            console.error('Error getting checkins pending', error)
            throw new Error('Error getting checkins pending')
        }
    }

    public static async get_checkouts_pending(status_pending_connection) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKOUT} WHERE status =?`
            const params = [status_pending_connection]

            const result = await DatabaseAdapter.getAll(query, params)

            return result
        } catch (error) {
            console.error('Error getting checkouts pending', error)
            throw new Error('Error getting checkouts pending')
        }
    }

    public static async get_checkins_by_id(id) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKIN} WHERE _id =?`
            const params = [parseInt(id)]

            const result = await DatabaseAdapter.getAll(query, params)

            return result
        } catch (error) {
            console.error('Error getting checkins by id', error)
            throw new Error('Error getting checkins by id')
        }
    }

    public static async updateCheckoutStatus(
        _id: string,
        status: number,
    ): Promise<boolean> {
        try {
            const query = `UPDATE ${TABLE_NAME.SCHEDULE_CHECKOUT} SET status = ? WHERE _id = ?`
            const params = [status, _id]

            const result = await DatabaseAdapter.run(query, params)

            return result && result.changes > 0 ? true : false
        } catch (error) {
            console.error('Error updating checkout status', error)
            throw new Error('Error updating checkout status')
        }
    }

    public static async updateCheckinStatus(
        _id,
        status,
        checkin_id,
    ): Promise<boolean> {
        try {
            const query = `UPDATE ${TABLE_NAME.SCHEDULE_CHECKIN} SET status = ?, checkin_id = ? WHERE _id = ?`
            const params = [status, checkin_id, _id]

            const result = await DatabaseAdapter.run(query, params)

            return result && result.changes > 0 ? true : false
        } catch (error) {
            console.error('Error updating checkin status', error)
            throw new Error('Error updating checkin status')
        }
    }

    public static async get_checkout_by_id(checkin_id_local) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKOUT} WHERE checkin_id_local = ? `
            const params = [checkin_id_local.toString()]

            const result = await DatabaseAdapter.run(query, params)

            return result
        } catch (error) {
            console.error('Error getting checkout by id', error)
            throw new Error('Error getting checkout by id')
        }
    }

    public static async get_newstores_pending(status_pending_connection) {
        try {
            const posQuery = `SELECT * FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} WHERE campaign_status = ?`
            const posParams = [status_pending_connection]

            const pendingPos = (await DatabaseAdapter.getAll(
                posQuery,
                posParams,
            )) as PendingPosRow[]

            if (pendingPos && pendingPos.length > 0) {
                const storeIds = pendingPos
                    .map((item) => `'${item.store_id}'`)
                    .join(',')
                const storeQuery = `SELECT * FROM ${TABLE_NAME.SCHEDULE_STORES} WHERE _id IN (${storeIds})`

                const storesData = (await DatabaseAdapter.getAll(
                    storeQuery,
                )) as StoreDataRow[]

                // Combinar los datos de ambas tablas en un solo array
                const combinedData = pendingPos.map((pos: PendingPosRow) => {
                    let store = storesData.find(
                        (store) => store._id === pos.store_id,
                    )
                    if (store) {
                        store = { ...store, schedule_id: pos.schedule_id }
                    }
                    return {
                        ...pos,
                        storeDetails: store || {},
                    }
                })
                return combinedData
            }
        } catch (error) {
            console.error('Error getting newstores pending', error)
            throw new Error('Error getting newstores pending')
        }
    }

    public static async updateStoreRecords(oldStoreId, newStoreId): Promise<void> {
        try {
            // Primer UPDATE en la tabla SCHEDULES_POS
            const posQuery = `UPDATE ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} 
            SET store_id = ?, campaign_status = ? 
            WHERE store_id = ?`

            const posParams = [
                newStoreId,
                FORM_SCHEDULE_STATUS.COMPLETED,
                oldStoreId,
            ]

            const posResult = await DatabaseAdapter.run(posQuery, posParams)

            console.log(
                `SCHEDULES_POS updated for Store ID ${oldStoreId} to ${newStoreId}`,
            )
        } catch (error) {
            console.error('Error updating store records', error)
            throw new Error('Error updating store records')
        }
    }

    public static async getPendingsImage() {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.UPLOAD_IMAGES_PENDING}`
            const result = await DatabaseAdapter.getAll(query)
            return result
        } catch (error) {
            console.error('Error getting pendings image', error)
            throw new Error('Error getting pendings image')
        }
    }

    public static async deletePendingImage(filename): Promise<boolean> {
        try {
            const query = `DELETE FROM ${TABLE_NAME.UPLOAD_IMAGES_PENDING} WHERE filename = ?`

            const params = [filename]

            const result = await DatabaseAdapter.run(query, params)

            return result && result.changes > 0 ? true : false
        } catch (error) {
            console.error('Error deleting pending image', error)
            throw new Error('Error deleting pending image')
        }
    }

    public static async saveAllLinksAssetsPS(dataLinks: string[]): Promise<void> {
        try {
            for (let index = 0; index < dataLinks.length; index++) {
                const link = dataLinks[index]

                const statusNoDownload = 0

                const query = `INSERT INTO ${SCHEDULES_STORE_NAMES.ASSETS_PF_LINKS}
                                (indexRoute, status, rute)
                                VALUES (?, ?, ?);`

                const paramsQuery = [index, statusNoDownload, link]

                await DatabaseAdapter.run(query, paramsQuery)
            }

            console.log(`Links inserted successfully:`)
        } catch (error) {
            console.error('Error saving links assets perfect store', error)
        }
    }

    public static async getProgressStatus(scheduleId: string, statusMap: Object) {
        try {
            const queryTotalStores = `SELECT COUNT(*) as total 
                             FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} 
                             WHERE schedule_id = ?;`

            const paramsTotalStores = [scheduleId]

            // const totalStores = await DatabaseAdapter.getAllAsync(queryTotalStores, paramsTotalStores)
            const totalStoresResult = await DatabaseAdapter.getFirst(
                queryTotalStores,
                paramsTotalStores,
            )
            const totalStores = (totalStoresResult as any)?.total || 0
            // console.log("1125 --- 🚀 ~ ScheduleServices ~ getProgressStatus ~ totalStores:", totalStores)

            const queryAdv = `
                            SELECT status, COUNT(*) as count 
                            FROM (
                                SELECT adv.pos_id, adv.schedule_id, adv.status
                                FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} AS adv
                                INNER JOIN (
                                    SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                                    FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES}
                                    WHERE schedule_id = ? AND pos_id IS NOT NULL
                                    GROUP BY pos_id, schedule_id
                                ) AS latest_adv
                                ON adv.pos_id = latest_adv.pos_id 
                                AND adv.schedule_id = latest_adv.schedule_id 
                                AND adv.date_modified = latest_adv.latest_date
                            ) AS recent_advances
                            GROUP BY status;`

            const paramsAdv = [scheduleId]

            const resultAdv = (await DatabaseAdapter.getAll(
                queryAdv,
                paramsAdv,
            )) as StatusCountRow[]

            let statusCounts = resultAdv.map((row) => ({
                _id: row?.status || '',
                label: statusMap[row.status]?.label || 'Unknown',
                value: row.count,
                color_hex: statusMap[row.status]?.color_hex || '#000000', // Default color if not mapped
            }))

            // Calcular las tiendas sin avances (status desconocido)
            const totalAdvances = resultAdv.reduce((sum, row) => sum + row.count, 0)
            const pending = totalStores - totalAdvances

            if (pending > 0) {
                statusCounts.push({
                    _id: '0',
                    label: statusMap[0]?.label || 'Unknown',
                    value: pending,
                    color_hex: statusMap[0]?.color_hex || '#000000',
                })
            }

            return statusCounts
        } catch (error) {
            console.error('Error getting progress status', error)
            throw new Error('Error getting progress status')
        }
    }

    public static async getStoresFromSchedule(
        pageNumber,
        pageSize,
        scheduleID,
        campaignStatus,
        lat,
        lng,
        radius,
        schedule_free,
    ): Promise<any[]> {
        try {
            const fetchStores = async (currentRadius, accumulatedStores = []) => {
                const queryStore = `
                                SELECT pos.*, stores.name, stores.code, stores.address, stores.segment, stores.cluster, 
                                       adv.forms AS forms_advances, pos.forms_relevant, pos.forms_featured, 
                                       COALESCE(adv.status, 0) AS campaign_status
                                FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} AS pos 
                                INNER JOIN ${TABLE_NAME.SCHEDULE_STORES} AS stores 
                                ON pos.store_id = stores._id
                                LEFT JOIN (
                                    SELECT adv.pos_id, adv.schedule_id, adv.forms, adv.status 
                                    FROM ${TABLE_NAME.SCHEDULE_ADVANCES} AS adv
                                    INNER JOIN (
                                        SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                                        FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                                        GROUP BY pos_id, schedule_id
                                    ) AS latest_adv
                                    ON adv.pos_id = latest_adv.pos_id 
                                    AND adv.schedule_id = latest_adv.schedule_id 
                                    AND adv.date_modified = latest_adv.latest_date
                                ) AS adv
                                ON pos.store_id = adv.pos_id AND pos.schedule_id = adv.schedule_id 
                                WHERE pos.schedule_id = ?;`

                let paramsStore = [scheduleID]

                const resultStore = (await DatabaseAdapter.getAll(
                    queryStore,
                    paramsStore,
                )) as GenericScheduleStoreRow[]

                const stores = resultStore.map((item) => ({
                    _id: schedule_free ? item._id : item.store_id,
                    schedule_id: item.schedule_id,
                    name: item.name,
                    code: item.code,
                    address: item.address,
                    forms: item.forms ? JSON.parse(item.forms) : [],
                    campaign_status: item.campaign_status ? item.campaign_status : 0,
                    lat: item.lat,
                    lng: item.lng,
                    forms_relevant: item.forms_relevant
                        ? JSON.parse(item.forms_relevant)
                        : [],
                    forms_featured: item.forms_featured
                        ? JSON.parse(item.forms_featured)
                        : [],
                    segment: item.segment ?? '',
                    forms_advances: item.forms_advances
                        ? JSON.parse(item.forms_advances)
                        : [],
                    cluster: item.cluster ?? '',
                    distance: newcalculateDistance(lat, lng, item.lat, item.lng), // Calcula la distancia
                }))

                accumulatedStores.push(...stores)

                if (campaignStatus !== null && campaignStatus !== -1) {
                    if (campaignStatus === 0) {
                        accumulatedStores = accumulatedStores.filter(
                            (item) => item.campaign_status == 0,
                        )
                        // Ordenar las tiendas pendientes por distancia
                        accumulatedStores.sort((a, b) => a.distance - b.distance)
                    } else {
                        accumulatedStores = accumulatedStores.filter(
                            (item) => item.campaign_status == campaignStatus,
                        )
                    }
                } else {
                    accumulatedStores.sort(
                        (a, b) => b.campaign_status - a.campaign_status,
                    )
                    // Ordenar las pendientes por distancia
                    const pendingStores = accumulatedStores.filter(
                        (item) => item.campaign_status === 0,
                    )
                    pendingStores.sort((a, b) => a.distance - b.distance)

                    // Reorganizar acumuladas: primero las no pendientes, luego las pendientes
                    accumulatedStores = [
                        ...accumulatedStores.filter(
                            (item) => item.campaign_status !== 0,
                        ),
                        ...pendingStores,
                    ]
                }

                // Filtrar las tiendas con campaign_status = 3
                const priorityStores = accumulatedStores.filter(
                    (item) => item.campaign_status === 4,
                )

                // Filtrar el resto de las tiendas
                const otherStores = accumulatedStores.filter(
                    (item) => item.campaign_status !== 4,
                )

                // Ordenar el resto de las tiendas por distancia
                otherStores.sort((a, b) => a.distance - b.distance)

                // Combinar ambas listas: primero las tiendas con campaign_status = 3, luego el resto ordenadas por distancia
                accumulatedStores = [...priorityStores, ...otherStores]

                //@FixMe: devolver todas las tiendas sin paginado y resolver de front como no tildar la vista
                const startIndex = pageNumber * pageSize
                const endIndex = startIndex + pageSize
                const paginatedStores = accumulatedStores.slice(startIndex, endIndex)
                //  console.log("1351 -- 🚀 ~ schedulesService ~ fetchStores ~ paginatedStores:", paginatedStores)

                if (pageSize != 0) {
                    // resolve(paginatedStores)
                    return paginatedStores
                } else {
                    // resolve(accumulatedStores)
                    return accumulatedStores
                }
            }

            const result = await fetchStores(radius)

            return result
        } catch (error) {
            console.error('Error getting stores from schedule', error)
            throw new Error('Error getting stores from schedule')
        }
    }

    public static async getFormStatusFromAdvances(
        schedule_id,
        form_id,
        dateSelected,
    ) {
        try {
            const query = `SELECT * 
                        FROM ${TABLE_NAME.SCHEDULE_ADVANCES} 
                        WHERE schedule_id = ? AND form_id = ?;`

            const params = [schedule_id, form_id]

            const result = await DatabaseAdapter.getFirst(query, params)
            // console.log("1294 --- 🚀 ~ ScheduleServices ~ getFormStatusFromAdvances ~ result:", result)

            return result
        } catch (error) {
            console.error('Error getting form status from advances', error)
            throw new Error('Error getting form status from advances')
        }
    }

    public static async isTotalAssetsDownloaded(): Promise<boolean> {
        try {
            const query = `SELECT COUNT(*) as count 
                        FROM ${SCHEDULES_STORE_NAMES.ASSETS_PF_LINKS}
                        WHERE status = 0;`

            const result = await DatabaseAdapter.getFirst(query)
            // console.log("1306 -- isTotalAssetsDownloaded - 🚀 ~ ScheduleServices ~ isTotalAssetsDownloaded ~ result:", result)

            const count: number = (result as any)?.count || 0

            return count === 0
        } catch (error) {
            console.error('Error checking total assets downloaded', error)
            throw new Error('Error checking total assets downloaded')
        }
    }

    public static async getProgressByForms(schedule_id, form_ids): Promise<number> {
        try {
            if (Array.isArray(form_ids) && form_ids.length > 0) {
                const queryAdv = `SELECT * FROM ${TABLE_NAME.SCHEDULE_ADVANCES} WHERE schedule_id = ?;`
                const paramsAdv = [schedule_id]

                const resultsAdv = (await DatabaseAdapter.getAll(
                    queryAdv,
                    paramsAdv,
                )) as FormStoreRow[]

                let count = 0
                let storesCounted = new Set()

                for (let i = 0; i < resultsAdv.length; i++) {
                    const item = resultsAdv[i]

                    try {
                        if (item.forms) {
                            const formsArray = JSON.parse(item.forms)
                            formsArray.forEach((form) => {
                                if (
                                    form_ids.includes(form._id) &&
                                    !storesCounted.has(item.pos_id)
                                ) {
                                    storesCounted.add(item.pos_id)
                                    count += 1
                                }
                            })
                        }
                    } catch (error) {
                        console.error('Error al parsear forms:', error)
                    }
                }

                // Consulta a FORMS_QUESTION_ANSWERS por forms locales

                const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} WHERE schedule_id = ? AND form_id IN (${form_ids
                    .map(() => '?')
                    .join(
                        ',',
                    )}) AND status NOT IN (${FORM_SCHEDULE_STATUS.BLOCKED}, ${FORM_SCHEDULE_STATUS.PENDING}, ${
                    FORM_SCHEDULE_STATUS.IN_PROGRESS
                })`

                const params = [schedule_id, ...form_ids]

                const answerRows = (await DatabaseAdapter.getAll(
                    query,
                    params,
                )) as AnswerStoreRow[]

                for (let j = 0; j < answerRows.length; j++) {
                    const answerItem = answerRows[j]
                    if (!storesCounted.has(answerItem.store_id)) {
                        storesCounted.add(answerItem.store_id)
                        count += 1
                    }
                }

                return count
            } else {
                throw new Error(
                    'Invalid form_ids parameter. Must be a non-empty array.',
                )
            }
        } catch (error) {
            console.error('Error getting progress by forms', error)
            throw new Error('Error getting progress by forms')
        }
    }

    public static async getFormName(formId) {
        try {
            const query = `SELECT name_form FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS} WHERE _id = ?;`
            const params = [formId]

            const result = await DatabaseAdapter.getFirst(query, params)
            console.log(
                '1376 -- 🚀 ~ ScheduleServices ~ getFormName ~ result:',
                result,
            )

            return result ? (result as any).name_form : null
        } catch (error) {
            console.error('Error getting form name', error)
            throw new Error('Error getting form name')
        }
    }

    public static async get_total_checkin_count(schedule_id) {
        try {
            const queryNew = `
                                SELECT COUNT(*) as count
                                FROM (
                                    SELECT adv.pos_id, adv.schedule_id, adv.status
                                    FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} AS adv
                                    INNER JOIN (
                                        SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                                        FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES}
                                        WHERE schedule_id = ? AND pos_id IS NOT NULL
                                        GROUP BY pos_id, schedule_id
                                    ) AS latest_adv
                                    ON adv.pos_id = latest_adv.pos_id 
                                    AND adv.schedule_id = latest_adv.schedule_id 
                                    AND adv.date_modified = latest_adv.latest_date
                                    WHERE adv.status IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION})
                                ) AS recent_advances;
                            `
            const params = [schedule_id]

            const result = await DatabaseAdapter.getFirst(queryNew, params)
            console.log(
                '1404 -- 🚀 ~ ScheduleServices ~ get_total_checkin_count ~ result:',
                result,
            )

            return result ? (result as any).count : 0
        } catch (error) {
            console.error('Error getting total checkin count', error)
            throw new Error('Error getting total checkin count')
        }
    }

    public static async getForm(formId) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS} WHERE _id = ?;`

            const params = [formId]

            const result = await DatabaseAdapter.getFirst(query, params)

            if (result) {
                const form = result as any
                form.type_form = JSON.parse(form.type_form)
                form.contents = JSON.parse(form.contents)
                form.segments = JSON.parse(form.segments)
                form.tags = JSON.parse(form.tags)
                // Parse new columns safely
                try {
                    form.scores = form.scores ? JSON.parse(form.scores) : []
                } catch (e) {
                    form.scores = []
                }
                try {
                    form.weights = form.weights ? JSON.parse(form.weights) : []
                } catch (e) {
                    form.weights = []
                }
                return form
            } else {
                return null
                // resolve(null) // El formulario no fue encontrado
            }
        } catch (error) {
            console.error('Error getting form', error)
            throw new Error('Error getting form')
        }
    }

    public static async countCompletedObjectivesForSchedule(schedule_id) {
        try {
            const query = `SELECT * FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} 
                             WHERE schedule_id = ?`

            const params = [schedule_id]

            const records = (await DatabaseAdapter.getAll(
                query,
                params,
            )) as ScheduleRecordRow[]

            if (records.length === 0) {
                return 0 // No hay registros para la agenda
            }

            let completedCount = 0

            records.forEach((record) => {
                let objectives = []
                let forms = []

                // Parsear objectives y forms
                try {
                    if (record.objectives) {
                        objectives = JSON.parse(record.objectives)
                    }
                    if (record.forms) {
                        forms = JSON.parse(record.forms)
                    }
                } catch (parseError) {
                    console.error('Error parsing objectives or forms:', parseError)
                    return
                }

                // Verifica si todos los objectives están en forms
                if (
                    objectives &&
                    objectives.length > 0 &&
                    forms &&
                    forms.length > 0
                ) {
                    const allObjectivesCompleted = objectives.every((objective) =>
                        forms.some((form) => form._id === objective._id),
                    )

                    if (allObjectivesCompleted) {
                        completedCount++
                    }
                }
            })

            return completedCount // Devuelve el total de registros completados
        } catch (error) {
            console.error('Error counting completed objectives for schedule', error)
            throw new Error('Error counting completed objectives for schedule')
        }
    }

    public static async getFormsAnswers(
        schedule_id,
        form_id,
        store_id = null,
        register_id = null,
        repeat = null,
    ) {
        // await DatabaseAdapter.initialiceDatabase()
        try {
            let query
            let queryParams

            // ✅ FIX: Generar day_unique_id al inicio para filtrar por día actual
            const generateIdDate = generateIdDateNow()

            if (register_id) {
                query = `SELECT _id, answers, date_init, repeat, status, totalScore, scoreObtained, cant_questions_yes_na, progress_questions_yes_na, scoreTotalQuestionsPonderar, name_form, questions, heladera, create_refrigerator, type_form, form_id_father, day_unique_id
                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                    WHERE _id = ?;`
                queryParams = [register_id]
            } else {
                if (store_id) {
                    if (repeat && repeat == 1) {
                        // ✅ FIX: Formularios repetibles - filtrar por día actual
                        query = `SELECT _id, answers, date_init, repeat, status, totalScore, scoreObtained, cant_questions_yes_na, progress_questions_yes_na, scoreTotalQuestionsPonderar, name_form, questions, heladera, create_refrigerator, type_form, form_id_father, day_unique_id
                                FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND day_unique_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                        queryParams = [
                            schedule_id,
                            form_id,
                            store_id,
                            generateIdDate,
                        ]
                    } else {
                        // ✅ FIX: Formularios normales - filtrar por día actual
                        query = `SELECT _id, answers, date_init, repeat, status, totalScore, scoreObtained, cant_questions_yes_na, progress_questions_yes_na, scoreTotalQuestionsPonderar, name_form, questions, heladera, create_refrigerator, type_form, form_id_father, day_unique_id
                                FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND day_unique_id = ?;`
                        queryParams = [
                            schedule_id,
                            form_id,
                            store_id,
                            generateIdDate,
                        ]
                    }
                } else {
                    // ✅ FIX: Sin store_id - filtrar por día actual
                    query = `SELECT _id, answers, date_init, repeat, status, totalScore, scoreObtained, cant_questions_yes_na, progress_questions_yes_na, scoreTotalQuestionsPonderar, name_form, questions, heladera, create_refrigerator, type_form, form_id_father, day_unique_id
                        FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                        WHERE schedule_id = ? AND form_id = ? AND day_unique_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                    queryParams = [schedule_id, form_id, generateIdDate]
                }
            }
            const result = await DatabaseAdapter.getAll(query, queryParams)
            // console.log("1650 ===== 🚀 ~ ScheduleServices ~ getFormsAnswers ~ result:", result)

            if (result.length > 0) {
                // ✅ FIX: Validar que el registro sea del día actual (cuando no se busca por register_id)
                if (!register_id) {
                    const todayRecord = result.find(
                        (r: any) => r.day_unique_id === generateIdDate,
                    )

                    if (!todayRecord) {
                        console.warn(
                            '⚠️ getFormsAnswers: No se encontró registro para hoy:',
                            {
                                schedule_id,
                                form_id,
                                store_id,
                                day_unique_id_esperado: generateIdDate,
                                registros_encontrados: result.map((r: any) => ({
                                    day_unique_id: r.day_unique_id,
                                    date_init: r.date_init,
                                    status: r.status,
                                })),
                            },
                        )
                        return {
                            answers: [],
                            date_init: null,
                            form: null,
                        }
                    }

                    const row =
                        typeDatabaseResult<FormQuestionAnswerRow>(todayRecord)
                    const answers = JSON.parse(row.answers)
                    const questions = JSON.parse(row.questions)
                    const type_form = JSON.parse(row.type_form)

                    console.log(
                        '✅ getFormsAnswers: Registro del día actual encontrado:',
                        {
                            day_unique_id: row.day_unique_id,
                            answersCount: answers.length,
                            form_id,
                        },
                    )

                    return {
                        fqa_id: row._id,
                        answers: answers,
                        date_init: row.date_init,
                        status: row.status,
                        repeat: row.repeat,
                        totalScore: row.totalScore,
                        scoreObtained: row.scoreObtained,
                        cant_questions_yes_na: row.cant_questions_yes_na,
                        progress_questions_yes_na: row.progress_questions_yes_na,
                        scoreTotalQuestionsPonderar: row.scoreTotalQuestionsPonderar,
                        name_form: row.name_form,
                        questions: questions,
                        heladera: row.heladera,
                        create_refrigerator: row.create_refrigerator,
                        type_form: type_form,
                        form_id_father: row.form_id_father,
                        day_unique_id: row.day_unique_id,
                    }
                } else {
                    // Búsqueda por register_id específico (no validar día)
                    const row = typeDatabaseResult<FormQuestionAnswerRow>(result[0])
                    const answers = JSON.parse(row.answers)
                    const questions = JSON.parse(row.questions)
                    const type_form = JSON.parse(row.type_form)

                    return {
                        fqa_id: row._id,
                        answers: answers,
                        date_init: row.date_init,
                        status: row.status,
                        repeat: row.repeat,
                        totalScore: row.totalScore,
                        scoreObtained: row.scoreObtained,
                        cant_questions_yes_na: row.cant_questions_yes_na,
                        progress_questions_yes_na: row.progress_questions_yes_na,
                        scoreTotalQuestionsPonderar: row.scoreTotalQuestionsPonderar,
                        name_form: row.name_form,
                        questions: questions,
                        heladera: row.heladera,
                        create_refrigerator: row.create_refrigerator,
                        type_form: type_form,
                        form_id_father: row.form_id_father,
                        day_unique_id: row.day_unique_id,
                    }
                }
            } else {
                return {
                    answers: [],
                    date_init: null,
                    form: null,
                }
            }
        } catch (error) {
            console.log('Error getting form answers:', error)
            return null
        }
    }

    public static async updateStatusLinkAssetsPS(status, rute): Promise<void> {
        // await DatabaseAdapter.initialiceDatabase()
        try {
            const query = `UPDATE ${TABLE_NAME.SCHEDULE_ASSETS_PF_LINKS}
                            SET status = ?
                            WHERE rute = ?;`
            const paramsQuery = [status, rute]

            await DatabaseAdapter.run(query, paramsQuery)
        } catch (error) {
            console.log('Error updating status link assets perfect store:', error)
            return null
        }
    }

    public static async addForm(
        form,
        wise = false,
        heladera = false,
        create_refrigerator = false,
        form_id_father = '',
    ): Promise<void> {
        try {
            const query = `SELECT COUNT(*) FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS} WHERE _id = ?`
            const params = [form._id]

            const result = await DatabaseAdapter.getFirst(query, params)

            const count = result['COUNT(*)']
            console.log('1608 🚀 ~ ScheduleServices ~ addForm ~ count:', count)

            if (count === 0) {
                let insertForm = [
                    form._id,
                    form.index_form,
                    form.repeat,
                    form.can_repeat,
                    form.icon,
                    form.check_in,
                    form.name_form,
                    form.icon_check,
                    JSON.stringify(form.type_form),
                    JSON.stringify(form.contents),
                    JSON.stringify(form.segments),
                    typeof form.status !== 'undefined' && form.status !== null
                        ? form.status
                        : 0, // status (preserve server status when provided)
                    form.progress,
                    form.totalScore,
                    form.show_barcode,
                    JSON.stringify(form.tags),
                    wise,
                    heladera,
                    create_refrigerator,
                    form_id_father,
                    JSON.stringify(form.scores || []),
                    JSON.stringify(form.weights || []),
                ]

                const insertQuery = `
                    INSERT INTO ${TABLE_NAME.SCHEDULE_STORE_FORMS} (
                        _id,
                        index_form,
                        repeat,
                        can_repeat,
                        icon,
                        check_in,
                        name_form,
                        icon_check,
                        type_form,
                        contents,
                        segments,
                        status,
                        progress,
                        totalScore,
                        show_barcode,
                        tags,
                        wise,
                        heladera,
                        create_refrigerator,
                        form_id_father,
                        scores,
                        weights
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                await DatabaseAdapter.run(insertQuery, insertForm)
            } else {
                if (heladera) {
                    // this.updateQuestionForms(form) //TODO FALTA AGREGAR ESTA FN
                }
            }
        } catch (error) {
            console.error('Error adding form', error)
            throw new Error('Error adding form')
        }
    }

    public static async getFormsWise(): Promise<any[]> {
        try {
            const query = `SELECT * FROM ${SCHEDULES_STORE_NAMES.FORMS} WHERE wise = 1;`
            let forms = (await DatabaseAdapter.getAll(query)) as FormRow[]

            try {
                for (const form of forms) {
                    form.contents = JSON.parse(form.contents)
                    form.type_form = JSON.parse(form.type_form)
                    try {
                        form.scores = form.scores ? JSON.parse(form.scores) : []
                    } catch (e) {
                        form.scores = []
                    }
                    try {
                        form.weights = form.weights ? JSON.parse(form.weights) : []
                    } catch (e) {
                        form.weights = []
                    }
                }
            } catch (error) {}

            return forms
        } catch (error) {
            console.error('Error getting forms wise', error)
            throw new Error('Error getting forms wise')
        }
    }

    public static async deleteFormAnswer(
        schedule_id,
        form_id,
        store_id = null,
        day_unique_id = null,
        retryCount = 0,
    ) {
        const MAX_RETRIES = 3
        const RETRY_DELAY = 100

        try {
            let query
            let queryParams

            if (store_id) {
                if (day_unique_id) {
                    query = `DELETE FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                        WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND day_unique_id = ?;`
                    queryParams = [schedule_id, form_id, store_id, day_unique_id]
                } else {
                    query = `DELETE FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                        WHERE schedule_id = ? AND form_id = ? AND store_id = ?;`
                    queryParams = [schedule_id, form_id, store_id]
                }
            } else {
                if (day_unique_id) {
                    query = `DELETE FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                        WHERE schedule_id = ? AND form_id = ? AND day_unique_id = ?;`
                    queryParams = [schedule_id, form_id, day_unique_id]
                } else {
                    query = `DELETE FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                        WHERE schedule_id = ? AND form_id = ?;`
                    queryParams = [schedule_id, form_id]
                }
            }

            const result = await DatabaseAdapter.run(query, queryParams)
            return result
        } catch (error: any) {
            // Manejar database locked con retry
            if (
                error?.message?.includes('database is locked') &&
                retryCount < MAX_RETRIES
            ) {
                console.warn(
                    `⚠️ [deleteFormAnswer] Database locked, retrying ${retryCount + 1}/${MAX_RETRIES}...`,
                )
                await new Promise((resolve) =>
                    setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                )
                return this.deleteFormAnswer(
                    schedule_id,
                    form_id,
                    store_id,
                    day_unique_id,
                    retryCount + 1,
                )
            }
            console.error('Error deleting form answer', error)
            throw new Error('Error deleting form answer')
        }
    }

    public static async deleteAllTablesSchedule() {
        try {
            const countCampaing = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_CAMPAINGS};`,
            )
            if (countCampaing && (countCampaing as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_CAMPAINGS};`,
                )
            }

            const countSchedule = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULES};`,
            )
            if (countSchedule && (countSchedule as any).count > 0) {
                await DatabaseAdapter.run(`DELETE FROM ${TABLE_NAME.SCHEDULES};`)
            }

            const countSchedulePos = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS};`,
            )
            if (countSchedulePos && (countSchedulePos as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS};`,
                )
            }

            const countScheduleAdvances = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_ADVANCES};`,
            )
            if (countScheduleAdvances && (countScheduleAdvances as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_ADVANCES};`,
                )
            }

            const countForms = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS};`,
            )
            if (countForms && (countForms as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS};`,
                )
            }

            const countStores = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_STORES};`,
            )
            if (countStores && (countStores as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_STORES};`,
                )
            }

            const countFormsAdditionals = await DatabaseAdapter.getFirst(
                `SELECT COUNT(*) as count FROM ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS};`,
            )
            if (countFormsAdditionals && (countFormsAdditionals as any).count > 0) {
                await DatabaseAdapter.run(
                    `DELETE FROM ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS};`,
                )
            }
        } catch (error) {
            console.error('Error deleting all tables schedule', error)
            throw new Error('Error deleting all tables schedule')
        }
    }

    public static async getStoreScheduleAdvances(
        scheduleId,
        storeId,
        distributor = false,
    ) {
        try {
            const query = distributor
                ? `SELECT * FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} WHERE schedule_id = ? AND distributor_id = ? ORDER BY date_modified DESC LIMIT 1;`
                : `SELECT * FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} WHERE schedule_id = ? AND pos_id = ? ORDER BY date_modified DESC LIMIT 1;`

            const params = [scheduleId, storeId]

            const result = await DatabaseAdapter.getFirst(query, params)

            return result
        } catch (error) {
            throw new Error('Error getting store schedule advances: ' + error)
        }
    }

    public static async getStore(storeId) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_STORES} WHERE _id = ?;`
            const params = [storeId]

            const store = await DatabaseAdapter.getFirst(query, params)

            return store
        } catch (error) {
            throw new Error('Error getting store: ' + error)
        }
    }

    public static async getFormAndUpdateSecondaryAction(
        formId,
        storeId,
        secondary_actions,
    ) {
        try {
            const query = `SELECT * FROM ${SCHEDULES_STORE_NAMES.FORMS} WHERE _id = ?`
            const params = [formId]

            let form = (await DatabaseAdapter.getFirst(query, params)) as any

            form.contents = JSON.parse(form.contents)

            form.contents.forEach((question) => {
                if (
                    question.input_type &&
                    question.input_type['_id'] &&
                    question.input_type['_id'] === ID_DROPDOWN_USERS
                ) {
                    question.secondary_actions = secondary_actions
                }
            })

            this.updateFormSecondaryAction(formId, JSON.stringify(form.contents))
        } catch (error) {
            throw new Error(
                'Error getting form and updating secondary action: ' + error,
            )
        }
    }

    public static async updateFormSecondaryAction(formId, arrayFormsModified) {
        try {
            const query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS}
                            SET contents = ?
                            WHERE _id = ?;`
            const params = [arrayFormsModified, formId]

            await DatabaseAdapter.run(query, params)
        } catch (error) {
            throw new Error('Error updating form secondary action: ' + error)
        }
    }

    public static async getPerfectStoreRelationByStore(store_id) {
        try {
            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_STORES_PF_RELATION} WHERE pos_id = ?;`
            const params = [store_id]

            let store = (await DatabaseAdapter.getFirst(query, params)) as any

            if (store) {
                store.forms_id = JSON.parse(store.forms_id)

                const sql = `SELECT * FROM ${SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE} WHERE _id IN (${store.forms_id.map(() => '?').join(',')});`

                const forms = await DatabaseAdapter.getAll(sql, store.forms_id)

                if (forms && forms.length > 0) {
                    const formsUpdate = forms.map((form: FormRow) => {
                        return {
                            ...form,
                            medias: form.medias ? JSON.parse(form.medias) : [],
                            type: form.type ? JSON.parse(form.type) : {},
                        }
                    })
                    // console.log('5224 --- formsUpdate: ', formsUpdate)
                    return formsUpdate
                } else {
                    return []
                }
            } else {
                return []
            }
        } catch (error) {
            throw new Error('Error adding schedules batch: ' + error)
        }
    }

    public static async saveFormAnswers(form) {
        try {
            const {
                schedule_id,
                form_id,
                store_id,
                repeat,
                questions,
                progress,
                totalScore,
                answers = '[]',
                status,
            } = form

            try {
                const answersLen =
                    typeof answers === 'string'
                        ? JSON.parse(answers || '[]').length
                        : (answers || []).length
                console.log('[LOG][saveFormAnswers] entry:', {
                    schedule_id,
                    form_id,
                    store_id,
                    status,
                    answersLen,
                })
            } catch (err) {
                console.log(
                    '[LOG][saveFormAnswers] entry (parsing answers failed):',
                    { schedule_id, form_id, store_id, status },
                )
            }

            if (JSON.parse(questions).length > 0) {
                const { cantQuestionPonderar, scoreTotalQuestionsPonderar } =
                    getCantQuestionPonderar(questions)
                const date_init = new Date().toISOString()

                let query, queryParams

                if (store_id) {
                    if (repeat == 1) {
                        query = `SELECT COUNT(*) as count 
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                        queryParams = [schedule_id, form_id, store_id]
                    } else {
                        query = `SELECT COUNT(*) as count 
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            WHERE schedule_id = ? AND form_id = ? AND store_id = ?;`
                        queryParams = [schedule_id, form_id, store_id]
                    }
                } else {
                    query = `SELECT COUNT(*) as count 
                        FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                        WHERE schedule_id = ? AND form_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                    queryParams = [schedule_id, form_id]
                }

                const countResult = await DatabaseAdapter.getFirst(
                    query,
                    queryParams,
                )
                const count = (countResult as any)?.count || 0
                // console.log("1977 --- 🚀 ~ ScheduleServices ~ saveFormAnswers ~ count:", count)

                if (count === 0) {
                    // agrego el registro porque no existe
                    let insertQuery, insertForm

                    if (store_id) {
                        insertForm = [
                            repeat,
                            date_init,
                            schedule_id,
                            form_id,
                            store_id,
                            status,
                            answers,
                            questions,
                            progress,
                            totalScore,
                            form.scoreObtained,
                            JSON.stringify({}), // scoresByKey
                            JSON.stringify({}), // totalByKey
                            cantQuestionPonderar,
                            form.progress_questions_yes_na,
                            scoreTotalQuestionsPonderar,
                            form.name_form,
                            form.heladera,
                            form.create_refrigerator,
                            JSON.stringify(form.type_form),
                            form.form_id_father,
                            form.checkout,
                        ]

                        insertQuery = `INSERT INTO ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} (
                                repeat, 
                                date_init, 
                                schedule_id, 
                                form_id, 
                                store_id, 
                                status, 
                                answers, 
                                questions, 
                                progress, 
                                totalScore, 
                            scoreObtained, 
                            scoresByKey,
                            totalByKey,
                            cant_questions_yes_na, 
                            progress_questions_yes_na, 
                            scoreTotalQuestionsPonderar, 
                                name_form, 
                                heladera, 
                                create_refrigerator, 
                                type_form, 
                                form_id_father,
                            checkout
                        ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`
                    } else {
                        insertForm = [
                            repeat,
                            date_init,
                            schedule_id,
                            form_id,
                            '',
                            status,
                            answers,
                            questions,
                            progress,
                            totalScore,
                            0,
                            cantQuestionPonderar,
                            0,
                            scoreTotalQuestionsPonderar,
                            form.name_form,
                            form.heladera,
                            form.create_refrigerator,
                            JSON.stringify(form.type_form),
                            form.form_id_father,
                        ]

                        insertQuery = `INSERT INTO ${TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE} (
                            repeat, 
                            date_init, 
                            schedule_id, 
                            form_id, 
                            store_id, 
                            status, 
                            answers, 
                            questions, 
                            progress, 
                            totalScore, 
                            scoreObtained, 
                            cant_questions_yes_na, 
                            progress_questions_yes_na, 
                            scoreTotalQuestionsPonderar, 
                            name_form, 
                            heladera, 
                            create_refrigerator, 
                            type_form, 
                            form_id_father
                        ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`
                    }

                    // console.log("2038 --- 🚀 ~ ScheduleServices ~ saveFormAnswers ~ insertForm:", insertForm)
                    // console.log('2039 --- 🚀 ~ ScheduleServices ~ saveFormAnswers ~ insertQuery:', insertQuery)

                    const resInsert = await DatabaseAdapter.run(
                        insertQuery,
                        insertForm,
                    )
                    // console.log("2078 --- 🚀 ~ ScheduleServices ~ saveFormAnswers ~ resInsert:", resInsert)

                    // ya lo cree
                    // busco el registro creado

                    let getQuery, queryParams

                    if (store_id) {
                        getQuery = `    SELECT *
                                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                            WHERE schedule_id = ? AND form_id = ? AND store_id = ?;`

                        queryParams = [schedule_id, form_id, store_id]
                    } else {
                        getQuery = `    SELECT *
                                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                            WHERE schedule_id = ? AND form_id = ?;`

                        queryParams = [schedule_id, form_id]
                    }

                    const result = await DatabaseAdapter.getFirst(
                        getQuery,
                        queryParams,
                    )
                    // console.log("2100 ---- 🚀 ~ ScheduleServices ~ saveFormAnswers ~ result:", result)

                    if (result) {
                        return {
                            end: 'saveFormAnswers',
                            result: result,
                            message: 'Agrego el registro con exito: saveFormAnswers',
                        }
                    } else {
                        return {
                            end: 'saveFormAnswers',
                            result: null,
                            message:
                                'No se encontro el registro creado: saveFormAnswers',
                        }
                    }
                } else {
                    // ya existe el registro - ACTUALIZAR campos importantes

                    let updateQuery, updateParams

                    if (store_id) {
                        updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            SET questions = ?,
                                heladera = ?,
                                create_refrigerator = ?,
                                type_form = ?,
                                form_id_father = ?,
                                name_form = ?
                            WHERE schedule_id = ? AND form_id = ? AND store_id = ?;`

                        updateParams = [
                            questions,
                            form.heladera,
                            form.create_refrigerator,
                            JSON.stringify(form.type_form),
                            form.form_id_father,
                            form.name_form,
                            schedule_id,
                            form_id,
                            store_id,
                        ]
                    } else {
                        updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            SET questions = ?,
                                heladera = ?,
                                create_refrigerator = ?,
                                type_form = ?,
                                form_id_father = ?,
                                name_form = ?
                            WHERE schedule_id = ? AND form_id = ?;`

                        updateParams = [
                            questions,
                            form.heladera,
                            form.create_refrigerator,
                            JSON.stringify(form.type_form),
                            form.form_id_father,
                            form.name_form,
                            schedule_id,
                            form_id,
                        ]
                    }

                    await DatabaseAdapter.run(updateQuery, updateParams)
                    console.log('✅ Registro existente actualizado con:', {
                        heladera: form.heladera,
                        form_id_father: form.form_id_father,
                        form_id,
                    })

                    // Leer el registro actualizado
                    let getQuery, queryParams

                    if (store_id) {
                        getQuery = `SELECT *
                                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                    WHERE schedule_id = ? AND form_id = ? AND store_id = ?;`

                        queryParams = [schedule_id, form_id, store_id]
                    } else {
                        getQuery = `SELECT *
                                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                    WHERE schedule_id = ? AND form_id = ?;`

                        queryParams = [schedule_id, form_id]
                    }

                    const result = await DatabaseAdapter.getFirst(
                        getQuery,
                        queryParams,
                    )

                    if (result) {
                        return {
                            end: 'saveFormAnswers',
                            result: result,
                            message:
                                'Registro existente actualizado exitosamente: saveFormAnswers',
                        }
                    } else {
                        return {
                            end: 'saveFormAnswers',
                            result: null,
                            message:
                                'No se encontro el registro actualizado: saveFormAnswers',
                        }
                    }
                }
            }
        } catch (error) {
            throw new Error('Error saving form answers: ' + error)
        }
    }

    public static async validateCheckins(schedule_id: string) {
        try {
            const query = `SELECT * 
                FROM ${TABLE_NAME.SCHEDULE_ADVANCES} 
                WHERE schedule_id = ? AND status = 4 
                ORDER BY date_init DESC;`

            const params = [schedule_id]

            const schedule_advances = await DatabaseAdapter.getFirst(query, params)
            // console.log("2179 -- 🚀 ~ ScheduleServices ~ validateCheckins ~ schedule_advances:", schedule_advances)

            try {
                if (schedule_advances && (schedule_advances as any).pos_id) {
                    const store = this.getStore((schedule_advances as any).pos_id)
                    console.log(
                        '2335 -- 🚀 ~ ScheduleServices ~ validateCheckins ~ store:',
                        store,
                    )

                    if (store) {
                        return {
                            status: false,
                            store: store,
                            schedule_advances: schedule_advances,
                        }
                    } else {
                        return {
                            status: true,
                            store: null,
                            schedule_advances: schedule_advances,
                        }
                    }
                } else {
                    return {
                        status: true,
                        store: null,
                        schedule_advances: schedule_advances,
                    }
                }
            } catch (error) {
                throw new Error('1Error validating checkins: ' + error)
            }
        } catch (error) {
            console.error('Error validating checkins:', error)
            throw new Error('Error validating checkins: ' + error)
        }
    }

    public static async isValidDistanceCheckin(
        store_id,
        current_distance,
    ): Promise<boolean> {
        try {
            const { lat, lng } = current_distance

            let query = `
                                    SELECT maximum_distance_for_checkin, lat, lng
                                    FROM ${TABLE_NAME.SCHEDULE_STORES}
                                    WHERE _id = ?;
                        `
            let params = [store_id]

            const store = (await DatabaseAdapter.getFirst(query, params)) as any

            const maximum_distance_for_checkin = store.maximum_distance_for_checkin
            const latStore = store.lat
            const lngStore = store.lng

            if (
                !maximum_distance_for_checkin ||
                maximum_distance_for_checkin === 0
            ) {
                return true
            } else {
                const store_distance = distanceInMeters(lat, lng, latStore, lngStore)

                if (store_distance <= maximum_distance_for_checkin) {
                    console.log(
                        'la distancia en m de la que estoy de la tienda es menor o igual a la maxima seteada por la tienda para hacer checkin',
                    ) // la distancia en m de la que estoy de la tienda es menor o igual a la maxima seteada por la tienda para hacer checkin

                    return true
                } else {
                    console.log(
                        'la distancia en m de la que estoy de la tienda es mayor a la maxima seteada por la tienda para hacer checkin',
                    ) // la distancia en m de la que estoy de la tienda es menor o igual a la maxima seteada por la tienda para hacer checkin
                    return false
                }
            }
        } catch (error) {
            console.error('Error validating distance checkin:', error)
            throw new Error('Error validating distance checkin: ' + error)
        }
    }

    public static async get_schedule(schedule_id: string) {
        try {
            let query = `SELECT * FROM ${TABLE_NAME.SCHEDULES} WHERE _id = ?;`
            let params = [schedule_id]

            const scheduleRow = (await DatabaseAdapter.getFirst(
                query,
                params,
            )) as any

            if (scheduleRow) {
                const schedule_formate = {
                    _id: scheduleRow._id,
                    date_finish: scheduleRow.date_finish,
                    date_init: scheduleRow.date_init,
                    form_finish:
                        scheduleRow.form_finish.length > 6
                            ? JSON.parse(scheduleRow.form_finish)
                            : null,
                    form_init:
                        scheduleRow.form_init.length > 6
                            ? JSON.parse(scheduleRow.form_init)
                            : null,
                    stores: [], //JSON.parse(scheduleRow.stores), // [],
                    progress_diary: scheduleRow.progress_diary,
                    additional: JSON.parse(scheduleRow.additional),
                }

                return schedule_formate
            } else {
                console.error('No se encontró la agenda')
                return null
            }
        } catch (error) {
            console.error('Error getting schedule:', error)
            throw new Error('Error getting schedule: ' + error)
        }
    }

    public static async get_name_forms(forms_required_names, forms, forms_store) {
        try {
            let query = `SELECT name_form, _id FROM ${TABLE_NAME.SCHEDULE_STORE_FORMS} WHERE _id IN (${forms_store.map(() => '?').join(',')})`
            let params = [...forms_store]

            const get_forms = (await DatabaseAdapter.getAll(
                query,
                params,
            )) as FormRow[]

            if (get_forms && get_forms.length > 0) {
                let result_forms = []
                forms_required_names.map((name) => {
                    const form_name = get_forms.find((f) => f.name_form == name)
                    if (form_name && forms.some((f) => f == form_name._id)) {
                        result_forms.push({
                            _id: form_name._id,
                            name: form_name.name_form,
                        })
                    }
                })
                return result_forms
            } else {
                return null
            }
        } catch (error) {
            console.error('Error getting name forms:', error)
            throw new Error('Error getting name forms: ' + error)
        }
    }

    public static async upsertScheduleAdvanceLocal(
        schedule_id,
        store_id,
        status,
        dateInit,
        forms = [],
        objectives = [],
    ) {
        try {
            const normalizedObjectives = Array.isArray(objectives) ? objectives : []

            const normalizedForms = Array.isArray(forms) ? forms : []

            // Obtén la fecha local en formato YYYY-MM-DD (corregido: no UTC)
            const _now = new Date()
            _now.setMinutes(_now.getMinutes() - _now.getTimezoneOffset())
            const today = _now.toISOString().split('T')[0]

            const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                         WHERE schedule_id = ? AND pos_id = ? AND date_init >= ?`

            const params = [schedule_id, store_id, today]

            const existingRecord = (await DatabaseAdapter.getFirst(
                query,
                params,
            )) as any

            let existingForms = []

            if (existingRecord && existingRecord.forms) {
                try {
                    existingForms = JSON.parse(existingRecord.forms)
                } catch (parseError) {
                    console.error('Error parsing existing forms:', parseError)
                    return
                }
            }

            if (
                normalizedForms.length > 0 &&
                (existingForms.length == 0 ||
                    !existingForms.find((f) => f._id == normalizedForms[0]['_id']))
            ) {
                existingForms.push(normalizedForms[0])
            }

            const query2 = existingRecord
                ? `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                            SET forms = ?
                            WHERE _id = ?`
                : `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES}
                            (_id, schedule_id, pos_id, status, date_init, forms, objectives, date_modified)
                            VALUES (?, ?, ?, ?, ?, ?, ?, ?)`

            const formsJson = JSON.stringify(normalizedForms)
            const objectivesJson = JSON.stringify(normalizedObjectives)
            const uniqueId = generateUniqueId()

            const values = existingRecord
                ? [JSON.stringify(existingForms), existingRecord._id]
                : [
                      uniqueId,
                      schedule_id,
                      store_id,
                      status,
                      today,
                      formsJson,
                      objectivesJson,
                      today,
                  ]

            const result = await DatabaseAdapter.run(query2, values)
            //  console.log("2361 -- 🚀 ~ ScheduleServices ~ upsertScheduleAdvanceLocal ~ result:", result)
        } catch (error) {
            console.error('Error upserting schedule advance local:', error)
            throw new Error('Error upserting schedule advance local: ' + error)
        }
    }

    public static async updateStatusFormAnswerSchedule(
        status,
        schedule_id,
        form_id,
        store_id = null,
        from = 'null',
        register_id = null,
        retryCount = 0,
    ) {
        const MAX_RETRIES = 3
        const RETRY_DELAY = 150

        // 🔍 LOG: Caller y parámetros
        const caller = new Error().stack.split('\n')[2]?.trim() || 'unknown'
        console.log('📝 [TS][updateStatusFormAnswerSchedule] INICIO', {
            caller,
            status,
            schedule_id,
            form_id,
            store_id,
            from,
            register_id,
            retryCount,
        })

        try {
            let querySelect
            let queryParamsSelect

            if (register_id) {
                querySelect = `SELECT _id, status FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                            WHERE _id = ?;`
                queryParamsSelect = [register_id]
            } else {
                if (store_id) {
                    querySelect = `SELECT _id, status FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ? AND store_id = ?
                                ORDER BY _id DESC;`
                    queryParamsSelect = [schedule_id, form_id, store_id]
                } else {
                    querySelect = `SELECT _id, status FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ?
                                ORDER BY _id DESC;`
                    queryParamsSelect = [schedule_id, form_id]
                }
            }

            const result = (await DatabaseAdapter.getFirst(
                querySelect,
                queryParamsSelect,
            )) as any

            console.log(
                '🔍 [TS][updateStatusFormAnswerSchedule] SELECT result:',
                result
                    ? {
                          _id: result._id,
                          current_status: result.status,
                          new_status: status,
                      }
                    : 'NO RESULT',
            )

            // ✅ Si no se encuentra el registro y aún quedan reintentos, esperar y reintentar
            if (!result) {
                if (retryCount < MAX_RETRIES) {
                    console.warn(
                        `⚠️ [updateStatusFormAnswerSchedule] Registro no encontrado, retrying ${retryCount + 1}/${MAX_RETRIES}... (form: ${form_id}, store: ${store_id})`,
                    )
                    await new Promise((resolve) =>
                        setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                    )
                    return this.updateStatusFormAnswerSchedule(
                        status,
                        schedule_id,
                        form_id,
                        store_id,
                        from,
                        register_id,
                        retryCount + 1,
                    )
                }
                // Si ya se agotaron los reintentos, lanzar error
                throw new Error('No se encontró el registro')
            }

            let updatedId

            const registerId = result._id

            // Obtener registro completo para diagnóstico (heladera/create_refrigerator, store, form)
            let fullRecord: any = null
            try {
                fullRecord = await DatabaseAdapter.getFirst(
                    `SELECT _id, schedule_id, form_id, store_id, status, heladera, create_refrigerator, name_form FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} WHERE _id = ?;`,
                    [registerId],
                )
                try {
                    console.log(
                        '[LOG][updateStatusFormAnswerSchedule] fullRecord for diagnostics:',
                        fullRecord,
                    )
                } catch (err) {}
            } catch (errFull) {
                try {
                    console.warn(
                        '[LOG][updateStatusFormAnswerSchedule] could not fetch fullRecord:',
                        errFull,
                    )
                } catch (err2) {}
            }

            let query
            let queryParams

            if (register_id) {
                query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                SET status = ?
                                WHERE _id = ?;`

                queryParams = [status, register_id]
                updatedId = register_id
            } else {
                if (store_id) {
                    query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                    SET status = ?
                                    WHERE _id = ?;`

                    queryParams = [status, registerId]
                    updatedId = registerId
                } else {
                    if (from == 'PENDING_CONNECTION') {
                        query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                        SET status = ?
                                        WHERE _id = ?;` //AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION})

                        queryParams = [status, registerId]
                        updatedId = registerId
                    } else {
                        query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                            SET status = ?
                            WHERE _id =?;` //
                        // WHERE schedule_id = ? AND form_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});` //

                        queryParams = [status, registerId]
                        updatedId = registerId
                    }
                }
            }

            console.log(
                '💾 [TS][updateStatusFormAnswerSchedule] SQL:',
                query.replace(/\s+/g, ' '),
            )
            console.log(
                '💾 [TS][updateStatusFormAnswerSchedule] PARAMS:',
                queryParams,
            )

            const update = await DatabaseAdapter.run(query, queryParams)

            console.log(
                '✅ [TS][updateStatusFormAnswerSchedule] UPDATE completado:',
                {
                    updatedId,
                    status,
                    changes: update.changes,
                },
            )

            return {
                ...update,
                updatedId: updatedId,
            }
        } catch (error: any) {
            // ✅ Manejar "database is locked" con retry
            if (
                error.message &&
                error.message.includes('database is locked') &&
                retryCount < MAX_RETRIES
            ) {
                console.warn(
                    `⚠️ [updateStatusFormAnswerSchedule] Database locked, retrying ${retryCount + 1}/${MAX_RETRIES}...`,
                )
                await new Promise((resolve) =>
                    setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                )
                return this.updateStatusFormAnswerSchedule(
                    status,
                    schedule_id,
                    form_id,
                    store_id,
                    from,
                    register_id,
                    retryCount + 1,
                )
            }
            console.error('Error updating status form answer schedule:', error)
            throw new Error('Error updating status form answer schedule: ' + error)
        }
    }

    public static async getFormsRealizedByStore(
        schedule_id: string,
        store_id: string,
    ): Promise<any[]> {
        try {
            const query = `SELECT * FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} WHERE schedule_id = ? AND store_id = ?;`

            const params = [schedule_id, store_id]

            const result = (await DatabaseAdapter.getAll(query, params)) as FormRow[]

            if (result && result.length > 0) {
                let modifiedResult = result
                    .map((form) => {
                        form.answers = form.answers ? JSON.parse(form.answers) : []
                        return form
                    })
                    .filter((form) => form.answers && form.answers.length > 0)

                return modifiedResult
            } else {
                return []
            }
        } catch (error) {
            console.error('Error getting forms realized by store:', error)
            throw new Error('Error getting forms realized by store: ' + error)
        }
    }

    public static async updateStatusSendForm(
        status,
        schedule_id,
        form_id,
        store_id = null,
        from = 'null',
        register_id = null,
    ) {
        // 🔍 LOG: Caller y parámetros
        const caller = new Error().stack.split('\n')[2]?.trim() || 'unknown'
        console.log('📝 [TS][updateStatusSendForm] INICIO', {
            caller,
            status,
            schedule_id,
            form_id,
            store_id,
            from,
            register_id,
        })

        try {
            let querySelect
            let queryParamsSelect

            if (register_id) {
                querySelect = `SELECT _id, status_send FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                            WHERE _id = ?;`
                queryParamsSelect = [register_id]
            } else {
                if (store_id) {
                    querySelect = `SELECT _id, status_send FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ? AND store_id = ?
                                ORDER BY _id DESC;`
                    queryParamsSelect = [schedule_id, form_id, store_id]
                } else {
                    querySelect = `SELECT _id, status_send FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                WHERE schedule_id = ? AND form_id = ?
                                ORDER BY _id DESC;`
                    queryParamsSelect = [schedule_id, form_id]
                }
            }

            const result = (await DatabaseAdapter.getFirst(
                querySelect,
                queryParamsSelect,
            )) as any

            console.log(
                '🔍 [TS][updateStatusSendForm] SELECT result:',
                result
                    ? {
                          _id: result._id,
                          current_status_send: result.status_send,
                          new_status_send: status,
                      }
                    : 'NO RESULT',
            )

            const registerId = result._id

            let query
            let queryParams

            if (register_id) {
                query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                SET status_send = ?
                                WHERE _id = ?;`

                queryParams = [status, register_id]
            } else {
                if (store_id) {
                    query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                    SET status_send = ?
                                    WHERE _id = ?;`

                    queryParams = [status, registerId]
                } else {
                    if (from == 'PENDING_CONNECTION') {
                        query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                        SET status_send = ?
                                        WHERE _id = ?;`

                        queryParams = [status, registerId]
                    } else {
                        query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                            SET status_send = ?
                            WHERE _id =?;`

                        queryParams = [status, registerId]
                    }
                }
            }

            console.log(
                '💾 [TS][updateStatusSendForm] SQL:',
                query.replace(/\s+/g, ' '),
            )
            console.log('💾 [TS][updateStatusSendForm] PARAMS:', queryParams)

            const resultUpdate = await DatabaseAdapter.run(query, queryParams)

            console.log('✅ [TS][updateStatusSendForm] UPDATE completado:', {
                registerId,
                status_send: status,
                changes: resultUpdate.changes,
            })

            if (resultUpdate) {
                console.log(
                    '1535 -- Registro actualizado con exito: updateStatusFormAnswerSchedule',
                    status,
                    from,
                )
                return
            } else {
                console.error('Error updating status send form')
            }
        } catch (error) {
            console.error('Error updating status send form:', error)
            throw new Error('Error updating status send form: ' + error)
        }
    }

    public static async updateKeyCheckoutFQA(value, register_id) {
        try {
            const query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                    SET checkout = ?
                                    WHERE _id = ?;`

            const paramsQuery = [value, register_id]

            const result = await DatabaseAdapter.run(query, paramsQuery)

            if (result) {
                console.log(
                    `2572 - FORM QUESTIONS ANSWERS updated checkout = ${value} successfully:`,
                    result,
                )
                return
            } else {
                console.error('Error updating key checkout fqa')
                return
            }
        } catch (error) {
            console.error('Error updating key checkout fqa:', error)
            throw new Error('Error updating key checkout fqa: ' + error)
        }
    }

    public static async updateFormAnswerSchedule(
        newAnswer,
        schedule_id,
        form_id,
        store_id = null,
        remplaceAnswers = false,
        clearAnswers = false,
        type = 'null',
    ) {
        try {
            let query
            let queryParams

            if (store_id) {
                query = `SELECT answers, status
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} 
                            WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                queryParams = [schedule_id, form_id, store_id]
            } else {
                query = `SELECT answers, status
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} 
                            WHERE schedule_id = ? AND form_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                queryParams = [schedule_id, form_id]
            }

            const result = (await DatabaseAdapter.getFirst(
                query,
                queryParams,
            )) as any

            if (result) {
                let status = result.status

                if (
                    status != undefined &&
                    status != FORM_SCHEDULE_STATUS.IN_PROGRESS
                ) {
                    this.updateStatusFormAnswerSchedule(
                        FORM_SCHEDULE_STATUS.IN_PROGRESS,
                        schedule_id,
                        form_id,
                        store_id,
                        `opcion:${type}`,
                    )
                }

                let answers = JSON.parse(result.answers || '[]')

                if (remplaceAnswers) {
                    answers = []
                }

                let findIndex = -1

                if (newAnswer && newAnswer._id) {
                    findIndex = answers.findIndex(
                        (answer) =>
                            answer._id.toString() === newAnswer._id.toString(),
                    )
                }

                if (findIndex !== -1) {
                    // si lo encuentro..
                    // debo remplazar lo que me llega con lo que esta guardado actualmente y despues updatear
                    //  console.log('🟠670 -------- actualizo lo que esta por lo que me llega...')
                    answers[findIndex] = { ...answers[findIndex], ...newAnswer }
                } else {
                    // si no lo encuentro
                    // console.log('🔵744 -------- pusheo al array el answer nuevo...')
                    if (newAnswer) answers.push(newAnswer)
                }

                const updatedAnswers = JSON.stringify(answers)

                // actualizo
                let updateFormAnswer
                let insertQuery
                if (store_id) {
                    updateFormAnswer = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                                SET answers = ?
                                                WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND status NOT IN (${FORM_SCHEDULE_STATUS.PENDING_CONNECTION});`
                    insertQuery = [updatedAnswers, schedule_id, form_id, store_id]
                } else {
                    updateFormAnswer = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                                SET answers = ?
                                                WHERE schedule_id = ? AND form_id = ?;`
                    insertQuery = [updatedAnswers, schedule_id, form_id]
                }

                const resultUpdate = await DatabaseAdapter.run(
                    updateFormAnswer,
                    insertQuery,
                )
                console.log(
                    '2698 = 🚀 ~ ScheduleServices ~ updateFormAnswerSchedule ~ resultUpdate:',
                    resultUpdate,
                )

                // Leer registro actualizado para diagnostico
                try {
                    const row = await DatabaseAdapter.getFirst(
                        `SELECT _id, status, heladera, create_refrigerator, answers FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} WHERE schedule_id = ? AND form_id = ? ${
                            store_id ? 'AND store_id = ?' : ''
                        } LIMIT 1;`,
                        store_id
                            ? [schedule_id, form_id, store_id]
                            : [schedule_id, form_id],
                    )
                    try {
                        console.log(
                            '[LOG][updateFormAnswerSchedule] post-update row:',
                            row,
                        )
                    } catch (err) {}
                } catch (errRow) {
                    try {
                        console.warn(
                            '[LOG][updateFormAnswerSchedule] could not fetch post-update row:',
                            errRow,
                        )
                    } catch (err) {}
                }
            }
        } catch (error) {
            console.error('Error updating form answer schedule:', error)
            throw new Error('Error updating form answer schedule: ' + error)
        }
    }

    public static async upsertFormStatus(
        schedule_id,
        form_id,
        newStatus,
        dateInit,
        progress,
        scoreObtained,
    ) {
        try {
            const updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                                         SET status = ?, progress=?, score=?
                                         WHERE schedule_id = ? AND form_id = ?`

            const result = await DatabaseAdapter.run(updateQuery, [
                newStatus,
                progress,
                scoreObtained,
                schedule_id,
                form_id,
            ])

            if ((result as any).changes == 0) {
                // console.log('Form status updated successfully')

                const insertQuery = `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES}
                                                     (_id, schedule_id, form_id, status, date_init, progress, score)
                                                     VALUES (?, ?, ?, ?, ?, ?, ?)`

                const insertParams = [
                    generateUniqueId(),
                    schedule_id,
                    form_id,
                    newStatus,
                    dateInit,
                    progress,
                    scoreObtained,
                ]

                const insertResult = await DatabaseAdapter.run(
                    insertQuery,
                    insertParams,
                )

                return insertResult
            }
        } catch (error) {
            console.error('Error upserting form status:', error)
            throw new Error('Error upserting form status: ' + error)
        }
    }

    public static async removeKeyOldResponseFormAnswerSchedule(
        schedule_id,
        form_id,
        store_id = null,
        arrayHideQuestions,
    ) {
        try {
            let query
            let queryParams

            if (store_id) {
                query = `SELECT _id, answers
                        FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                        WHERE schedule_id = ? AND form_id = ? AND store_id = ?
                          AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION})
                        ORDER BY _id DESC LIMIT 1;`
                queryParams = [schedule_id, form_id, store_id]
            } else {
                if (schedule_id === 'wise') {
                    // FIX WISE: Buscar solo el registro activo mas reciente, excluyendo completados/pendientes
                    query = `SELECT _id, answers
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            WHERE schedule_id = ? AND form_id = ?
                              AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION})
                            ORDER BY date_init DESC
                            LIMIT 1;`
                    queryParams = [schedule_id, form_id]
                } else {
                    query = `SELECT _id, answers
                            FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                            WHERE schedule_id = ? AND form_id = ?;`
                    queryParams = [schedule_id, form_id]
                }
            }

            const result = (await DatabaseAdapter.getFirst(
                query,
                queryParams,
            )) as any

            if (result) {
                this.updateStatusFormAnswerSchedule(
                    FORM_SCHEDULE_STATUS.IN_PROGRESS,
                    schedule_id,
                    form_id,
                    store_id,
                )
                let answers = JSON.parse(result.answers || '[]')

                if (answers && answers.length > 0) {
                    answers = answers.filter(
                        (ans) => !arrayHideQuestions.includes(ans['_id']),
                    )
                }

                const updatedAnswers = JSON.stringify(answers)

                let updateFormAnswer
                let insertQuery
                if (store_id) {
                    updateFormAnswer = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                            SET answers = ?
                                            WHERE _id = ?;`
                    insertQuery = [updatedAnswers, result._id]
                } else {
                    if (schedule_id === 'wise' && result._id) {
                        // FIX WISE: Actualizar solo el registro especifico por _id
                        updateFormAnswer = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                                SET answers = ?
                                                WHERE _id = ?;`
                        insertQuery = [updatedAnswers, result._id]
                    } else {
                        updateFormAnswer = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                                SET answers = ?
                                                WHERE schedule_id = ? AND form_id = ?;`
                        insertQuery = [updatedAnswers, schedule_id, form_id]
                    }
                }

                const resultUpdate = await DatabaseAdapter.run(
                    updateFormAnswer,
                    insertQuery,
                )
            }
        } catch (error) {
            console.error(
                'Error removing key old response form answer schedule:',
                error,
            )
            throw new Error(
                'Error removing key old response form answer schedule: ' + error,
            )
        }
    }

    public static async get_checkin(store_id, schedule_id, distributor = false) {
        try {
            const query = distributor
                ? `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKIN} WHERE distributor_id = ? AND schedule_id = ?`
                : `SELECT * FROM ${TABLE_NAME.SCHEDULE_CHECKIN} WHERE store_id = ? AND schedule_id = ?`
            const params = [store_id, schedule_id]

            const checkinResult = (await DatabaseAdapter.getAll(
                query,
                params,
            )) as ActivityRow[]
            console.log(
                '2810 --- 🚀 ~ ScheduleServices ~ get_checkin ~ checkinResult:',
                checkinResult,
            )

            if (checkinResult && checkinResult.length > 0) {
                const check_ins = checkinResult.map((item) => ({
                    ...item,
                    activities: item.activities ? JSON.parse(item.activities) : [],
                }))
                return check_ins
            } else {
                return false
            }
        } catch (error) {
            console.error('Error getting checkin:', error)
            throw new Error('Error getting checkin: ' + error)
        }
    }

    public static async getFormsAnswersByStatus(status1, status2) {
        try {
            let query = `
                        SELECT *
                        FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} AS fqa
                        WHERE (status_send = ? OR status = ?)
                        AND (
                            (store_id IS NOT NULL AND store_id != '' AND checkout = 0)
                            OR (store_id IS NOT NULL AND store_id != '' AND checkout = 1 AND EXISTS (
                                SELECT 1
                                FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} AS sa
                                WHERE sa.status = 1
                                AND sa.schedule_id = fqa.schedule_id
                                AND sa.pos_id = fqa.store_id
                                AND sa.date_modified = (
                                    SELECT MAX(sub_sa.date_modified)
                                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} AS sub_sa
                                    WHERE sub_sa.schedule_id = sa.schedule_id
                                    AND sub_sa.pos_id = sa.pos_id
                                )
                            ))
                            OR (store_id IS NULL OR store_id = '')
                        );
                    `

            let queryParams = [status1, status2]

            const result = await DatabaseAdapter.getAll(query, queryParams)

            return result
        } catch (error) {
            console.error('Error getting forms answers by status:', error)
            throw new Error('Error getting forms answers by status: ' + error)
        }
    }

    public static async clearFqaAnswersById(
        fqaId: string,
        retryCount = 0,
    ): Promise<void> {
        const MAX_RETRIES = 3
        const RETRY_DELAY = 150

        try {
            const query = `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                                        SET answers = ?
                                        WHERE _id = ?;
                        `
            const params = ['[]', fqaId]

            const result = await DatabaseAdapter.run(query, params)
        } catch (error: any) {
            // ✅ Manejar "database is locked" con retry
            if (
                error.message &&
                error.message.includes('database is locked') &&
                retryCount < MAX_RETRIES
            ) {
                console.warn(
                    `⚠️ [clearFqaAnswersById] Database locked, retrying ${retryCount + 1}/${MAX_RETRIES}...`,
                )
                await new Promise((resolve) =>
                    setTimeout(resolve, RETRY_DELAY * (retryCount + 1)),
                )
                return this.clearFqaAnswersById(fqaId, retryCount + 1)
            }
            console.error('Error clearing fqa answers by id:', error)
            throw new Error('Error clearing fqa answers by id: ' + error)
        }
    }

    public static async searchStoresByText(
        scheduleID: string,
        searchText: string,
    ): Promise<any[]> {
        try {
            let query = `
                WITH filtered_stores AS (
                        SELECT _id, name, code, address, segment, cluster 
                        FROM ${TABLE_NAME.SCHEDULE_STORES}
                        WHERE LOWER(name) LIKE LOWER(?) 
                        OR LOWER(code) LIKE LOWER(?) 
                        OR LOWER(address) LIKE LOWER(?)
                    )
                    SELECT pos.*, fs.name, fs.code, fs.address, fs.segment, fs.cluster, 
                           adv.forms AS forms_advances, pos.forms_relevant, pos.forms_featured, 
                           COALESCE(adv.status, 0) AS campaign_status
                    FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} AS pos 
                    INNER JOIN filtered_stores AS fs ON pos.store_id = fs._id
                    LEFT JOIN (
                        SELECT adv.pos_id, adv.schedule_id, adv.forms, adv.status 
                        FROM ${TABLE_NAME.SCHEDULE_ADVANCES} AS adv
                        INNER JOIN (
                            SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                            FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                            GROUP BY pos_id, schedule_id
                        ) AS latest_adv
                        ON adv.pos_id = latest_adv.pos_id 
                        AND adv.schedule_id = latest_adv.schedule_id 
                        AND adv.date_modified = latest_adv.latest_date
                    ) AS adv
                    ON pos.store_id = adv.pos_id AND pos.schedule_id = adv.schedule_id 
                    WHERE pos.schedule_id = ?;
            `

            let params = [scheduleID]

            if (searchText && searchText.trim() !== '') {
                params.unshift(
                    `%${searchText}%`,
                    `%${searchText}%`,
                    `%${searchText}%`,
                )
            }

            const stores = (await DatabaseAdapter.getAll(
                query,
                params,
            )) as StoreLocationRow[]

            if (!stores || stores.length === 0) {
                return []
            }

            return stores.map((store) => ({
                _id: store.store_id,
                schedule_id: store.schedule_id,
                name: store.name,
                code: store.code,
                address: store.address,
                forms: store.forms ? JSON.parse(store.forms) : [],
                campaign_status: store.campaign_status ?? 0,
                segment: store.segment ?? '',
                cluster: store.cluster ?? '',
            }))
        } catch (error) {
            console.error('Error searching stores by text:', error)
            throw new Error('Error searching stores by text: ' + error)
        }
    }

    public static async searchStoresFromSchedule(
        pageNumber,
        pageSize,
        scheduleID,
        campaignStatus,
        lat,
        lng,
        radius,
        schedule_free,
        dateSelected,
    ): Promise<any[]> {
        try {
            const fetchStores = async (currentRadius, accumulatedStores = []) => {
                const query = `
                    SELECT pos.*, stores.name, stores.code, stores.address, stores.segment, stores.cluster, 
                               adv.forms AS forms_advances, pos.forms_relevant, pos.forms_featured, 
                               COALESCE(adv.status, 0) AS campaign_status
                        FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} AS pos 
                        INNER JOIN ${TABLE_NAME.SCHEDULE_STORES} AS stores 
                        ON pos.store_id = stores._id
                        LEFT JOIN (
                            SELECT adv.pos_id, adv.schedule_id, adv.forms, adv.status 
                            FROM ${TABLE_NAME.SCHEDULE_ADVANCES} AS adv
                            INNER JOIN (
                                SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                                FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                                GROUP BY pos_id, schedule_id
                            ) AS latest_adv
                            ON adv.pos_id = latest_adv.pos_id 
                            AND adv.schedule_id = latest_adv.schedule_id 
                            AND adv.date_modified = latest_adv.latest_date
                        ) AS adv
                        ON pos.store_id = adv.pos_id AND pos.schedule_id = adv.schedule_id 
                        WHERE pos.schedule_id = ?
                `

                const params = [scheduleID]

                const storesResult = (await DatabaseAdapter.getAll(
                    query,
                    params,
                )) as StoreLocationRow[]

                if (!storesResult || storesResult.length === 0) {
                    return []
                }

                const stores = storesResult.map((store) => ({
                    _id: schedule_free ? store._id : store.store_id,
                    schedule_id: store.schedule_id,
                    name: store.name,
                    code: store.code,
                    address: store.address,
                    forms: store.forms ? JSON.parse(store.forms) : [],
                    campaign_status: store.campaign_status
                        ? store.campaign_status
                        : 0,
                    lat: store.lat,
                    lng: store.lng,
                    forms_relevant: store.forms_relevant
                        ? JSON.parse(store.forms_relevant)
                        : [],
                    forms_featured: store.forms_featured
                        ? JSON.parse(store.forms_featured)
                        : [],
                    segment: store.segment ?? '',
                    forms_advances: store.forms_advances
                        ? JSON.parse(store.forms_advances)
                        : [],
                    cluster: store.cluster ?? '',
                    distance: newcalculateDistance(lat, lng, store.lat, store.lng), // Calcula la distancia
                }))

                accumulatedStores.push(...stores)

                if (campaignStatus !== null && campaignStatus !== -1) {
                    if (campaignStatus === 0) {
                        accumulatedStores = accumulatedStores.filter(
                            (item) => item.campaign_status == 0,
                        )
                        // Ordenar las tiendas pendientes por distancia
                        accumulatedStores.sort((a, b) => a.distance - b.distance)
                    } else {
                        accumulatedStores = accumulatedStores.filter(
                            (item) => item.campaign_status == campaignStatus,
                        )
                    }
                } else {
                    accumulatedStores.sort(
                        (a, b) => b.campaign_status - a.campaign_status,
                    )
                    // Ordenar las pendientes por distancia
                    const pendingStores = accumulatedStores.filter(
                        (item) => item.campaign_status === 0,
                    )
                    pendingStores.sort((a, b) => a.distance - b.distance)

                    // Reorganizar acumuladas: primero las no pendientes, luego las pendientes
                    accumulatedStores = [
                        ...accumulatedStores.filter(
                            (item) => item.campaign_status !== 0,
                        ),
                        ...pendingStores,
                    ]
                }

                return accumulatedStores
            }

            const result = await fetchStores(radius)

            return result
        } catch (error) {
            console.error('Error searching stores from schedule:', error)
            throw new Error('Error searching stores from schedule: ' + error)
        }
    }
}

// ✅ Exportar la clase para poder importarla en otros archivos
export default ScheduleServices

// Commented out duplicate method - using the static version above
/*
    searchStoresFromSchedule = (pageNumber, pageSize, scheduleID, campaignStatus, lat, lng, radius, schedule_free, dateSelected) => {
        return new Promise((resolve, reject) => {
            const fetchStores = (currentRadius, accumulatedStores = []) => {
                db.transaction(
                    (tx) => {
                        let query = `
                        SELECT pos.*, stores.name, stores.code, stores.address, stores.segment, stores.cluster, 
                               adv.forms AS forms_advances, pos.forms_relevant, pos.forms_featured, 
                               COALESCE(adv.status, 0) AS campaign_status
                        FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} AS pos 
                        INNER JOIN ${SCHEDULES_STORE_NAMES.STORES} AS stores 
                        ON pos.store_id = stores._id
                        LEFT JOIN (
                            SELECT adv.pos_id, adv.schedule_id, adv.forms, adv.status 
                            FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} AS adv
                            INNER JOIN (
                                SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                                FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES}
                                GROUP BY pos_id, schedule_id
                            ) AS latest_adv
                            ON adv.pos_id = latest_adv.pos_id 
                            AND adv.schedule_id = latest_adv.schedule_id 
                            AND adv.date_modified = latest_adv.latest_date
                        ) AS adv
                        ON pos.store_id = adv.pos_id AND pos.schedule_id = adv.schedule_id 
                        WHERE pos.schedule_id = ?`

                        let params = [scheduleID]

                        tx.executeSql(
                            query,
                            params,
                            (_, result) => {
                                const rows = result.rows._array
                                //  console.log("🚀 ~ schedulesService ~ fetchStores ~ rows:", rows.length)

                                const stores = rows.map((item) => ({
                                    _id: schedule_free ? item._id : item.store_id,
                                    schedule_id: item.schedule_id,
                                    name: item.name,
                                    code: item.code,
                                    address: item.address,
                                    forms: item.forms ? JSON.parse(item.forms) : [],
                                    campaign_status: item.campaign_status ? item.campaign_status : 0,
                                    lat: item.lat,
                                    lng: item.lng,
                                    forms_relevant: item.forms_relevant ? JSON.parse(item.forms_relevant) : [],
                                    forms_featured: item.forms_featured ? JSON.parse(item.forms_featured) : [],
                                    segment: item.segment ?? '',
                                    forms_advances: item.forms_advances ? JSON.parse(item.forms_advances) : [],
                                    cluster: item.cluster ?? '',
                                    distance: newcalculateDistance(lat, lng, item.lat, item.lng), // Calcula la distancia
                                }))

                                accumulatedStores.push(...stores)

                                if (campaignStatus !== null && campaignStatus !== -1) {
                                    if (campaignStatus === 0) {
                                        accumulatedStores = accumulatedStores.filter((item) => item.campaign_status == 0)
                                        // Ordenar las tiendas pendientes por distancia
                                        accumulatedStores.sort((a, b) => a.distance - b.distance)
                                    } else {
                                        accumulatedStores = accumulatedStores.filter((item) => item.campaign_status == campaignStatus)
                                    }
                                } else {
                                    accumulatedStores.sort((a, b) => b.campaign_status - a.campaign_status)
                                    // Ordenar las pendientes por distancia
                                    const pendingStores = accumulatedStores.filter((item) => item.campaign_status === 0)
                                    pendingStores.sort((a, b) => a.distance - b.distance)

                                    // Reorganizar acumuladas: primero las no pendientes, luego las pendientes
                                    accumulatedStores = [...accumulatedStores.filter((item) => item.campaign_status !== 0), ...pendingStores]
                                }
                                resolve(accumulatedStores)
                            },
                            (_, error) => {
                                console.error('Query Execution Error:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Transaction Error:', error)
                        reject(error)
                    },
                )
            }

            fetchStores(radius)
        })
    }
    
}

export default ScheduleServices

function generateUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}
*/
